export const translations = {
  es: {
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      search: 'Buscar',
      loading: 'Cargando...',
      noResults: 'Sin resultados',
      confirm: 'Confirmar',
      back: 'Volver',
      close: 'Cerrar',
      yes: 'Sí',
      no: 'No',
      actions: 'Acciones',
      status: 'Estado',
      active: 'Activo',
      inactive: 'Inactivo',
      reason: 'Motivo',
      reasonRequired: 'Motivo obligatorio',
    },
    auth: {
      login: 'Iniciar Sesión',
      logout: 'Cerrar Sesión',
      email: 'Correo electrónico',
      password: 'Contraseña',
      loginTitle: 'AdamSched Fitness',
      loginSubtitle: 'Gestión de citas profesional',
      invalidCredentials: 'Credenciales inválidas',
      changePassword: 'Cambiar contraseña',
      currentPassword: 'Contraseña actual',
      newPassword: 'Nueva contraseña',
      forgotPassword: '¿Olvidaste tu contraseña?',
      forgotPasswordTitle: 'Recuperar contraseña',
      forgotPasswordSubtitle: 'Introduce tu email y te enviaremos un enlace para restablecer tu contraseña.',
      sendResetLink: 'Enviar enlace',
      resetLinkSent: 'Si el email existe en nuestro sistema, recibirás un enlace en breve.',
      backToLogin: 'Volver al inicio de sesión',
      resetPasswordTitle: 'Restablecer contraseña',
      confirmPassword: 'Confirmar contraseña',
      passwordsDoNotMatch: 'Las contraseñas no coinciden',
      resetPassword: 'Restablecer contraseña',
      resetSuccess: 'Tu contraseña ha sido restablecida correctamente. Redirigiendo al inicio de sesión...',
      resetInvalidToken: 'El enlace es inválido o ha caducado. Solicita uno nuevo.',
      requestNewLink: 'Solicitar un nuevo enlace',
    },
    nav: {
      planner: 'Planificador',
      clients: 'Clientes',
      requests: 'Solicitudes',
      services: 'Servicios',
      staff: 'Personal',
      settings: 'Configuración',
      centers: 'Centros',
      auditLog: 'Registro de auditoría',
      waitlist: 'Lista de espera',
      notifications: 'Notificaciones',
      dashboard: 'Dashboard',
      myPacks: 'Tus bonos y planes',
      costs: 'Costes',
      whatsappInbox: 'WhatsApp',
    },
    dashboard: {
      title: 'Dashboard',
      loadError: 'Error al cargar el dashboard',
      noData: 'Sin datos esta semana',
      allGood: 'Todo en orden',
      sessions: 'sesiones',
      sessionsLeft: 'restantes',
      vsLastMonth: 'vs mes ant.',
      outstanding: 'por cobrar',
      sections: {
        occupancy: 'Ocupación y asistencia',
        financial: 'Económico',
        alerts: 'Alertas',
      },
      occupancyWeek: 'Ocupación esta semana por servicio',
      attendanceMonth: 'Asistencia este mes',
      attended: 'Asistidos',
      noShow: 'No presentados',
      topClients: 'Top 5 clientes más activos',
      revenueMonth: 'Ingresos del mes',
      packsSold: 'Bonos vendidos este mes',
      pendingPayment: 'Pendiente de cobro',
      expiringSoon: 'Caducan en 30 días',
      debtClients: 'Clientes con deuda',
      lowSessions: 'Bonos casi agotados',
      saas: {
        allCentersActive: 'Todos los centros activos tienen actividad reciente',
        noBookings: 'sin reservas',
        lastBooking: 'última:',
        daysAgo: 'hace {{n}}d',
      },
    },
    planner: {
      title: 'Planificador',
      today: 'Hoy',
      dayView: 'Día',
      weekView: 'Semana',
      monthView: 'Mes',
      addBooking: 'Nueva reserva',
      noBookings: 'Sin reservas',
      capacity: 'Capacidad',
      selectClient: 'Seleccionar cliente',
      selectService: 'Seleccionar servicio',
      startTime: 'Hora de inicio',
      duration: 'Duración',
      minutes: 'minutos',
      slots: 'Slots',
      occupied: 'Ocupado',
      time: 'Hora',
      break: 'Descanso',
      template: 'Plantilla',
      applyTemplate: 'Aplicar plantilla',
      apply: 'Aplicar',
      noTemplatesHint: 'Sin plantillas. Crea una en Configuración → Horario',
      bookingsCreated: 'reservas creadas',
      bookingsSkipped: '{{n}} saltadas (ya existían)',
      breaksRegistered: '{{n}} descanso(s) registrado(s)',
      toast: {
        loadError: 'Error cargando datos',
        statusUpdated: 'Estado actualizado',
        statusError: 'Error actualizando estado',
        bookingDeleted: 'Reserva eliminada',
        bookingDeleteError: 'Error eliminando reserva',
        applyTemplateError: 'Error aplicando plantilla',
      },
    },
    bookings: {
      title: 'Reservas',
      status: {
        reserved: 'Reservado',
        attended: 'Asistió',
        noShow: 'No asistió',
        no_show: 'No presentado',
        cancelled: 'Cancelado',
      },
      assignedStaff: 'Personal',
      markAttended: 'Marcar asistencia',
      markNoShow: 'Marcar no asistió',
      noShowReason: 'Motivo de no asistencia',
      noShowReasonRequired: 'El motivo es requerido',
      moveBooking: 'Reserva movida',
      deleteConfirm: '¿Eliminar esta reserva?',
      capacityExceeded: 'Capacidad excedida para este horario',
      clientOverlap: 'El cliente ya tiene reserva en este horario',
      created: 'Reserva creada',
      debtWarning: 'Reserva sin bono pagado',
      debtNote: 'El cliente no tiene bono activo. Esta reserva cuenta hacia el límite de deuda.',
    },
    clients: {
      title: 'Clientes',
      addClient: 'Nuevo cliente',
      fullName: 'Nombre',
      surname: 'Apellido',
      phone: 'Teléfono',
      notes: 'Notas internas',
      bookingHistory: 'Historial de reservas',
      sessionPacks: 'Bonos y planes',
      noClients: 'Sin clientes',
      archived: 'Cliente archivado',
      deleted: 'Cliente eliminado',
    },
    sessionPacks: {
      title: 'Bonos y planes',
      addPack: 'Nuevo bono',
      totalSessions: 'Sesiones totales',
      remainingSessions: 'Sesiones restantes',
      price: 'Precio',
      noPacks: 'Sin bonos activos',
      sessionsRemaining: 'sesiones restantes',
      selectService: 'Seleccionar servicio',
      created: 'Bono creado',
      status: 'Estado',
      pendingPayment: 'Pago pendiente',
      paymentMethod: 'Método de pago',
      selectPaymentMethod: 'Selecciona método de pago',
      cash: 'Efectivo',
      card: 'Tarjeta',
      confirmDelete: 'Borrar bono',
      deleteRequiresReason: 'Debes indicar un motivo. Se registrará en auditoría.',
      expiresAt: 'Fecha de caducidad (opcional)',
      updated: 'Bono actualizado',
      deleted: 'Bono borrado',
      hasBookings: 'Este bono tiene citas asociadas y no puede eliminarse. ¿Quieres desactivarlo en su lugar?',
      deactivateTitle: '¿Desactivar bono?',
      deactivate: 'Desactivar bono',
      deactivated: 'Bono desactivado',
      allServices: 'Todos los servicios',
    },
    services: {
      title: 'Servicios',
      addService: 'Nuevo servicio',
      name: 'Nombre',
      color: 'Color',
      capacity: 'Capacidad por slot',
      defaultDuration: 'Duración predeterminada',
      slotsPerBooking: 'Slots por reserva',
      slots: 'slots',
      noServices: 'Sin servicios',
      created: 'Servicio creado',
      updated: 'Servicio actualizado',
      manageServices: 'Gestionar servicios',
      toast: {
        loadError: 'Error cargando servicios',
        nameRequired: 'El nombre es obligatorio',
        saveError: 'Error guardando servicio',
        confirmDelete: '¿Eliminar "{{name}}"?',
        deleted: 'Servicio eliminado',
        deleteError: 'Error eliminando servicio',
      },
    },
    requests: {
      title: 'Solicitudes',
      addRequest: 'Nueva solicitud',
      rawText: 'Texto original',
      detectedInfo: 'Información detectada',
      convertToBooking: 'Convertir en reserva',
      dismiss: 'Descartar',
      status: {
        pending: 'Pendiente',
        converted: 'Resuelta',
        dismissed: 'Descartada',
      },
      noRequests: 'Sin solicitudes pendientes',
      noResults: 'Sin resultados para esa búsqueda',
      processed: 'Procesadas',
      fields: {
        name: 'Nombre',
        phone: 'Teléfono',
        service: 'Servicio',
        dateTime: 'Fecha/Hora',
      },
      toast: {
        loadError: 'Error cargando solicitudes',
        textRequired: 'El texto es obligatorio',
        created: 'Solicitud creada',
        createError: 'Error creando solicitud',
        updated: 'Solicitud actualizada',
        updateError: 'Error actualizando solicitud',
      },
    },
    staff: {
      title: 'Personal',
      addStaff: 'Nuevo usuario',
      role: 'Rol',
      userCreated: 'Usuario creado',
      userUpdated: 'Usuario actualizado',
      clientNote: 'Se creará automáticamente un perfil de cliente vinculado a esta cuenta.',
      roles: {
        superAdmin: 'Super Admin',
        centerAdmin: 'Admin Centro',
        staff: 'Personal',
        client: 'Cliente',
      },
      noUsers: 'Sin usuarios',
      toast: {
        loadError: 'Error cargando usuarios',
        emailNameRequired: 'Email y nombre son obligatorios',
        passwordRequired: 'La contraseña es obligatoria para nuevos usuarios',
        clientAlreadyHasAccess: 'Este cliente ya tiene acceso (ya existe un usuario vinculado).',
        saveError: 'Error guardando usuario',
        confirmDelete: '¿Eliminar a "{{name}}"?',
        deleted: 'Usuario eliminado',
        deleteError: 'Error eliminando usuario',
      },
    },
    centers: {
      title: 'Centros',
      addCenter: 'Nuevo centro',
      name: 'Nombre',
      timezone: 'Zona horaria',
      openingTime: 'Hora de apertura',
      closingTime: 'Hora de cierre',
      slotDuration: 'Duración del slot',
      centerDetails: 'Detalles del centro',
      centerAdmin: 'Administrador del centro',
      adminName: 'Nombre del admin',
      adminEmailRequired: 'Email del admin requerido',
      adminPasswordRequired: 'Contraseña del admin requerida (min 6 caracteres)',
      adminNote: 'Este admin solo tendrá acceso a este centro.',
      noBilling: 'Centro sin cobro (demo/cortesía)',
      noBillingHelp: 'No se le facturará. La suscripción se crea con estado FREE y queda excluida del cobro mensual.',
      whatsappManagedElsewhere: 'Las credenciales de WhatsApp se configuran desde la pestaña «WhatsApp» (Provisión de WhatsApp).',
      created: 'Centro creado con admin',
      updated: 'Centro actualizado',
      noCenters: 'Sin centros',
      nameRequired: 'El nombre es obligatorio',
      manageCenters: 'Gestionar centros',
      deactivate: 'Desactivar',
      reactivate: 'Reactivar',
      deleteHard: 'Eliminar definitivamente',
      resetPassword: 'Resetear contraseña',
      exportClients: 'Exportar clientes CSV',
      exportClientsLoading: 'Exportando clientes CSV...',
      fichaClientTitle: 'Ficha cliente (configurable por centro)',
      fichaLabel: 'Apartados de la ficha',
      fichaTip: 'Activa/desactiva con el checkbox y ordena con las flechas.',
      rgpdLegalText: 'Texto legal RGPD por defecto',
      whatsappTitle: 'WhatsApp Business (por centro)',
      metaAccessToken: 'Access Token de Meta',
      phoneNumberId: 'Phone Number ID',
      moveUp: 'Subir',
      moveDown: 'Bajar',
      whatsapp: {
        statusLabel: 'Estado WhatsApp',
        provisionBtn: 'Provisionar WhatsApp',
        refreshStatus: 'Actualizar estado',
        status: {
          notConnected: 'No conectado',
          pendingReview: 'En revisión',
          pendingRegistration: 'Pendiente registro',
          registering: 'Registrando...',
          active: 'Activo',
          failed: 'Error',
          rateLimited: 'Límite de peticiones',
        },
        provision: {
          title: 'Conectar WhatsApp Business',
          accessToken: 'Access Token de Meta',
          wabaId: 'WABA ID',
          phoneNumberId: 'Phone Number ID',
          pin: 'PIN (6 dígitos)',
          pinHelp: 'PIN que protege el número en la Cloud API. Necesario para re-registrar.',
          displayName: 'Nombre del remitente (opcional)',
          submit: 'Provisionar manualmente',
          connectWithFacebook: 'Conectar con Facebook',
          embeddedSignupHint: 'Abre el asistente de Meta para vincular el WABA de este centro.',
          orManual: 'O introduce los datos manualmente',
        },
        toast: {
          provisionSuccess: 'WhatsApp provisionado correctamente',
          provisionError: 'Error al provisionar WhatsApp',
          statusRefreshed: 'Estado actualizado',
          statusError: 'Error al obtener estado de WhatsApp',
          sdkNotLoaded: 'SDK de Facebook no disponible. Recarga la página.',
          signupCancelled: 'Signup cancelado',
          noWabaData: 'No se recibieron datos del WABA — usa el formulario manual',
        },
        guide: {
          step1: { title: 'Abre Meta Business Manager', text: 'Ve a business.facebook.com → Cuentas de WhatsApp', btn: 'Abrir Meta Business' },
          step2: { title: 'Crea la cuenta WhatsApp del centro', text: 'Pulsa + Agregar → Crear nueva cuenta → introduce el nombre del centro' },
          step3: { title: 'Añade el número de teléfono', text: 'En la cuenta creada → Números de teléfono → Añadir número → introduce el número del centro. El cliente recibirá un SMS con el código de verificación.' },
          step4: { title: 'Copia el Phone Number ID', text: 'Administrador de WhatsApp → selecciona el número → copia el Identificador de número de teléfono' },
          step5: { title: 'Copia el WABA ID', text: 'En la cuenta de WhatsApp → copia el Identificador' },
          step6: { title: 'Define un PIN de seguridad' },
          connectBtn: 'Conectar WhatsApp',
        },
      },
      toast: {
        loadError: 'Error cargando centros',
        passwordReset: 'Contraseña reseteada',
        passwordResetError: 'No se pudo resetear la contraseña',
        confirmResetPassword: '¿Resetear la contraseña de {{label}}?\n\nSe generará una contraseña temporal y se mostrará para copiarla.',
        confirmDeactivate: '¿Desactivar este centro?',
        deactivated: 'Centro desactivado',
        deactivateError: 'Error al desactivar centro',
        reactivated: 'Centro reactivado',
        reactivateError: 'Error al reactivar centro',
        exportClientsError: 'Error al exportar clientes CSV',
        confirmDeleteHard: '¿Eliminar definitivamente este centro? Solo es posible si no tiene datos asociados.',
        deleted: 'Centro eliminado',
        cannotDelete: 'No se puede eliminar: hay datos asociados. Desactiva el centro.',
      },
    },
    settings: {
      title: 'Configuración',
      centerSettings: 'Configuración del centro',
      language: 'Idioma',
      profile: 'Perfil',
      connect: {
        title: 'Stripe Connect',
        description: 'Vincula la cuenta Stripe de tu centro mediante onboarding seguro.',
        status: 'Estado',
        action: 'Activar / continuar onboarding',
        requirements: 'Revisar requisitos',
        error: 'No se pudo iniciar Stripe Connect',
      },
      tabs: {
        general: 'General',
        center: 'Centro',
        schedule: 'Horario',
      },
      cancelRules: {
        title: 'Reglas de cancelación',
        rule: 'Regla',
        dayBefore: 'Día anterior',
        sameDay: 'Mismo día',
        cutoffDayBefore: 'Hora límite (día anterior)',
        cutoffSameDay: 'Hora límite (mismo día)',
        note: 'Fuera de regla: se marca NO_SHOW y descuenta sesión / genera deuda.',
      },
      weeklySchedule: {
        title: 'Horario Semanal',
        noTemplates: 'Sin plantillas',
        newTemplate: 'Nueva plantilla',
        editTemplate: 'Editar plantilla',
        breaks: 'Descansos',
        noBreaks: 'Sin descansos',
        slots: 'Slots',
        noSlots: 'Sin slots',
        add: 'Añadir',
        nameLabel: 'Nombre',
        namePlaceholder: 'Ej: Semana tipo A',
        clients: 'Clientes',
        searchClient: 'Buscar cliente...',
        editorDescription: 'Editor de plantilla semanal',
        // template-service-break-semantics (Hallazgo 5, task 9.1.1):
        // placeholders del editor de breaks de plantilla (Settings.js).
        breakGlobal: 'Global (slot entero)',
        breakAllVariants: 'Todas las variantes',
        // template-service-break-semantics (Hallazgo 6, task 9.3.1):
        // labels de los inputs horarios del editor de breaks (Settings.js:697-711).
        // El navegador ignora `placeholder` en `<input type="time">`, así que el
        // operador necesita ver qué lado del rango está rellenando.
        breakFrom: 'Desde',
        breakTo: 'Hasta',
      },
      days: {
        mon: 'Lun',
        tue: 'Mar',
        wed: 'Mié',
        thu: 'Jue',
        fri: 'Vie',
        sat: 'Sáb',
        sun: 'Dom',
      },
      toast: {
        loadTemplatesError: 'Error cargando plantillas',
        saveError: 'Error guardando configuración',
        saveTemplateError: 'Error guardando plantilla',
        deleteTemplateError: 'Error eliminando plantilla',
        templateNameRequired: 'El nombre es obligatorio',
        templateSaved: 'Plantilla guardada',
        templateDeleted: 'Plantilla eliminada',
        confirmDeleteTemplate: '¿Eliminar la plantilla "{{name}}"?',
        // template-service-break-semantics (Hallazgo 6, task 9.3.1):
        // guardia client-side: rechaza guardar una plantilla con descansos
        // sin horas. El input `<input type="time">` vacío muestra números
        // visuales pero su valor real es "" — confundirlo con un valor
        // guardado generaba PUTs con startTime/endTime vacíos.
        breakTimeRequired: 'Indica las horas de inicio y fin de cada descanso antes de guardar',
      },
    },
    auditLog: {
      title: 'Registro de auditoría',
      user: 'Usuario',
      action: 'Acción',
      entity: 'Entidad',
      timestamp: 'Fecha y hora',
      details: 'Detalles',
      detailMessages: {
        createdBooking: 'Reserva creada para {{client}} - {{service}}',
        deletedBooking: 'Reserva eliminada',
      },
      actions: {
        create: 'Creado',
        update: 'Actualizado',
        delete: 'Eliminado',
        deduct: 'Descontado',
        apply: 'Plantilla aplicada',
      },
      entities: {
        booking: 'Reserva',
        client: 'Cliente',
        user: 'Usuario',
        center: 'Centro',
        calendar: 'Servicio',
        session_pack: 'Bono',
        request: 'Solicitud',
        waitlist: 'Lista de espera',
        weekly_template: 'Plantilla semanal',
        unknown: 'Otro',
      },
      empty: 'No hay registros de auditoría',
      loadError: 'Error cargando registro de auditoría',
    },
    time: {
      today: 'Hoy',
      yesterday: 'Ayer',
      tomorrow: 'Mañana',
    },
    layout: {
      notifications: {
        markAllRead: 'Marcar todo leído',
        markRead: 'Marcar leído',
        empty: 'Sin notificaciones',
        open: 'Abrir',
      },
      waitlistOffer: {
        title: 'Plaza liberada — lista de espera',
        body: 'Se ha liberado un hueco por cancelación y se ha ofrecido al primer cliente en lista de espera.',
        clientLabel: 'Cliente',
        serviceLabel: 'Servicio',
        slotLabel: 'Slot',
        confirmBtn: 'OK — Confirmar',
      },
    },
    waitlist: {
      title: 'Lista de espera',
      newRequest: 'Nueva solicitud',
      cancelConfirm: '¿Cancelar esta entrada de lista de espera?',
      clientSelected: 'Cliente seleccionado',
      searchClient: 'Escribe y elige un cliente',
      searchClientPlaceholder: 'Cliente (buscar por nombre)',
      selectService: 'Servicio',
      selectDay: 'Selecciona día',
      timeCarousel: 'Hora (carrusel o escribir)',
      noEntries: 'Sin entradas en lista de espera.',
      position: 'Posición {{n}} en la lista',
      cancelRequest: 'Cancelar solicitud',
      force: 'Forzar',
      columns: {
        client: 'Cliente',
        service: 'Servicio',
        slot: 'Slot',
      },
      status: {
        waiting: 'Esperando',
        offered: 'Ofrecido',
        confirmed: 'Confirmado',
        expired: 'Expirado',
        cancelled: 'Cancelado',
      },
      toast: {
        loadError: 'Error cargando lista de espera',
        created: 'Entrada creada',
        forced: 'Forzado',
        cancelled: 'Cancelada',
        bookingConfirmed: 'Reserva confirmada desde lista de espera',
        fillRequired: 'Completa cliente, servicio y fecha/hora',
        cannotClose: 'No se pudo cerrar el aviso',
        cannotConfirm: 'No se pudo confirmar la oferta',
        cannotForce: 'No se pudo forzar',
        cannotCancel: 'No se pudo cancelar',
        cannotCreate: 'No se pudo crear',
      },
    },
    clientProfile: {
      access: {
        title: 'Acceso al área personal',
        enabled: 'Activado',
        disabled: 'Desactivado',
        resetPassword: 'Restablecer contraseña',
        disableAccess: 'Desactivar acceso',
        enableAccess: 'Activar acceso',
        dialogTitleReset: 'Restablecer acceso',
        dialogTitleEnable: 'Activar acceso',
        emailLabel: 'Correo electrónico *',
        passwordLabel: 'Contraseña *',
        adminNote: 'El admin define una nueva contraseña, la ve en pantalla y se la comunica al cliente.',
      },
      tabs: {
        ficha: 'Ficha',
        personal: 'Personal',
      },
      personal: {
        loading: 'Cargando personal…',
        emptyStaff: 'No hay personal activo',
        error: 'No se pudo cargar el personal',
      },
      sections: {
        personalData: 'Datos personales',
        rgpd: 'Privacidad y normas del centro',
      },
      fields: {
        firstName: 'Nombre',
        surname: 'Apellidos',
        phone: 'Teléfono',
        email: 'Email',
        birthDate: 'Fecha de nacimiento',
        professionalSector: 'Sector profesional',
        address: 'Dirección (opcional)',
        legalText: 'Texto legal (se almacena en el cliente)',
      },
      rgpd: {
        consent: 'Consentimiento RGPD',
        dateLabel: 'Fecha:',
      },
      toast: {
        loadError: 'Error al cargar el cliente',
        updated: 'Cliente actualizado',
        updateError: 'Error al actualizar el cliente',
        emailPasswordRequired: 'Email y contraseña son obligatorios',
        passwordUpdated: 'Contraseña actualizada',
        accessCreated: 'Acceso creado',
        accessReactivated: 'Acceso reactivado',
        accessError: 'No se pudo guardar el acceso',
        accessDisabled: 'Acceso desactivado',
        accessDisableError: 'No se pudo desactivar el acceso',
      },
    },

    contentEngine: {
      nav: 'Content Engine',
    },
    aiLeadScanner: {
      nav: 'Lead Scanner',
      title: 'AI Lead Scanner',
      todayFollowUps: {
        title: 'Seguimientos de hoy',
        empty: 'Sin seguimientos pendientes para hoy',
        overdueLabel: 'Atrasado',
      },
      activeFollowUps: {
        title: 'Seguimientos activos',
        empty: 'Sin seguimientos activos',
      },
      discardSuggestions: {
        title: 'Sugerencias de descarte',
        empty: 'Ningún lead ha alcanzado el límite de seguimientos',
      },
      filters: {
        sector: 'Sector',
        city: 'Ciudad',
        priority: 'Prioridad',
        status: 'Estado',
        temperature: 'Temperatura',
        minScore: 'Puntuación mínima',
        search: 'Buscar por nombre',
        searchPlaceholder: 'Nombre del negocio...',
        allSectors: 'Todos los sectores',
        allPriorities: 'Todas las prioridades',
        allStatuses: 'Todos los estados',
        allTemperatures: 'Todas',
        clear: 'Limpiar filtros',
      },
      table: {
        businessName: 'Negocio',
        sector: 'Sector',
        city: 'Ciudad',
        score: 'Score',
        priority: 'Prioridad',
        status: 'Estado',
        temperature: 'Temp.',
        lastContacted: 'Último contacto',
        nextFollowUp: 'Próximo seguimiento',
        actions: 'Acciones',
        noLeads: 'No hay leads con estos filtros',
        viewDetail: 'Ver ficha',
        never: '—',
        loadError: 'No se pudieron cargar los leads',
      },
      actions: {
        addLead: 'Añadir lead',
        importExcel: 'Importar Excel',
        analyzeSelected: 'Analizar seleccionados',
        discardSelected: 'Descartar seleccionados',
      },
      discardDialog: {
        title: '¿Descartar {{count}} lead(s)?',
        description: 'Podrás encontrarlos filtrando por estado "Descartado" más adelante. No es un borrado real — el lead sigue existiendo, solo cambia de estado.',
        confirm: 'Descartar',
      },
      addLeadModal: {
        businessName: 'Nombre del negocio',
        businessNameRequired: 'El nombre del negocio es obligatorio',
        province: 'Provincia',
        phone: 'Teléfono',
        email: 'Email',
        create: 'Crear lead',
        success: 'Lead creado correctamente',
        error: 'No se pudo crear el lead',
        duplicateReasonDomain: 'Ya existe un lead con esta misma web: {{name}}',
        duplicateReasonPhone: 'Ya existe un lead con este mismo teléfono: {{name}}',
        duplicateReasonNameCity: 'Ya existe un lead con el mismo nombre y ciudad: {{name}}',
        viewExisting: 'Ver lead existente',
      },
      importModal: {
        runDryRun: 'Analizar archivo',
        totalRows: 'Filas totales',
        imported: 'Se importarían',
        duplicates: 'Duplicados',
        invalidRows: 'Filas inválidas (sin nombre de negocio)',
        contactadoDefaultedWhatsapp: 'Estado "Contactado" — canal asignado por defecto: WhatsApp',
        followUpNoDate: 'Seguimiento sin fecha',
        addressUnparsed: 'Dirección sin parsear',
        unrecognizedStatuses: 'Estados no reconocidos',
        rowRef: 'Pestaña {{sheet}}, fila {{row}}',
        confirmWarning: 'Esto escribirá los leads reales en la base de datos. Revisa el resumen antes de confirmar.',
        confirmImport: 'Confirmar import',
        success: '{{count}} leads importados correctamente',
        error: 'No se pudo completar la importación',
      },
      pagination: {
        showing: 'Mostrando {{from}}–{{to}} de {{total}}',
        previous: 'Anterior',
        next: 'Siguiente',
      },
      calendar: {
        title: 'Calendario de seguimientos',
      },
      status: {
        NEW: 'Nuevo',
        READY_TO_CONTACT: 'Listo para contactar',
        CONTACTED_WHATSAPP: 'Contactado (WhatsApp)',
        CONTACTED_EMAIL: 'Contactado (Email)',
        CONTACTED_CALL: 'Contactado (Llamada)',
        FOLLOW_UP: 'Seguimiento',
        DEMO_PENDING: 'Demo pendiente',
        DEMO_SCHEDULED: 'Demo agendada',
        EVALUATING_PROPOSAL: 'Evaluando propuesta',
        CUSTOMER: 'Cliente',
        NOT_INTERESTED: 'No interesado',
        DISCARDED: 'Descartado',
        ERROR: 'Error',
      },
      priority: {
        high: 'Alta',
        medium: 'Media',
        low: 'Baja',
        discard: 'Descartar',
        unknown: 'Sin puntuar',
      },
      temperature: {
        HOT: 'Caliente',
        WARM: 'Templado',
        COLD: 'Frío',
      },
      sector: {
        personal_trainer: 'Entrenador personal',
        small_gym: 'Gimnasio pequeño',
        functional_training: 'Entrenamiento funcional',
        boutique_gym: 'Gimnasio boutique',
        cross_training: 'Cross training',
        pilates: 'Pilates',
        yoga: 'Yoga',
        physiotherapy: 'Fisioterapia',
        osteopathy: 'Osteopatía',
        nutritionist: 'Nutrición',
        psychologist: 'Psicología',
        massage_therapist: 'Masajista',
        manual_therapist: 'Terapeuta manual',
        wellness_center: 'Centro de bienestar',
        chiropractor: 'Quiropráctico',
        unknown: 'Sin definir',
      },
      leadDetail: {
        back: 'Volver',
        profile: 'Perfil',
        address: 'Dirección',
        website: 'Web',
        instagram: 'Instagram',
        notes: 'Notas',
        needsWebsite: 'Sin web propia',
        loadError: 'No se pudo cargar el lead',
        notFound: 'Lead no encontrado',
        markContacted: 'Marcar contactado',
        markContactedWhatsapp: 'Por WhatsApp',
        markContactedEmail: 'Por email',
        markContactedCall: 'Por llamada',
        changeStatus: 'Cambiar estado',
        markDiscard: 'Descartar',
        followUpCount: 'Seguimientos: {{count}}/{{limit}}',
        discardSuggestionDescription: 'Este lead ha alcanzado el límite de {{limit}} seguimientos sin avanzar. Puedes descartarlo o seguir intentándolo manualmente.',
        pasteManualContent: 'Pegar contenido de la web manualmente',
        pasteManualContentTitle: 'Pegar contenido de la web manualmente',
        pasteManualContentDescription: 'El análisis automático de la web falló al intentar acceder a ella. Pega aquí el texto que copies tú misma desde el navegador — el resto del análisis (sector, señales, puntuación, mensajes) se genera igual que siempre a partir de ese texto.',
        pasteManualContentLabel: 'Contenido de la web',
        markFollowUp: 'Marcar seguimiento',
        followUpDate: 'Fecha de seguimiento',
        followUpNote: 'Nota (opcional)',
        markNotInterested: 'No interesado',
        regenerateMessages: 'Regenerar mensajes',
        reanalyze: 'Re-analizar',
        actionSuccess: 'Hecho',
        actionError: 'No se pudo completar la acción',
        noAnalysisYet: 'Este lead todavía no tiene análisis. Usa "Re-analizar" para generarlo.',
        noMessagesYet: 'Este lead todavía no tiene mensajes generados.',
        save: 'Guardar',
        cancel: 'Cancelar',
        edit: 'Editar',
      },
      editLeadModal: {
        title: 'Editar lead',
        success: 'Lead actualizado correctamente',
        error: 'No se pudo actualizar el lead',
      },
      messageCard: {
        copy: 'Copiar',
        copied: 'Copiado al portapapeles',
        copyError: 'No se pudo copiar',
        words: 'palabras',
        subject: 'Asunto',
        exceedsLimit: 'Supera el límite recomendado de 180 palabras, revísalo antes de copiar',
        whatsappInitial: 'WhatsApp inicial',
        emailInitial: 'Email inicial',
        followUp1: 'Seguimiento 1',
        followUp2: 'Seguimiento 2',
        callScript: 'Guion de llamada',
        internalNotes: 'Notas internas',
      },
      scoreBreakdown: {
        positive: 'Señales positivas',
        negative: 'Señales negativas',
      },
      websiteAnalysis: {
        title: 'Análisis de la web',
        confidence: 'Confianza',
        excluded: 'Excluido',
        detectedSector: 'Sector detectado',
        evidence: 'Evidencia',
      },
      signals: {
        has_whatsapp: 'WhatsApp visible',
        has_online_booking: 'Reservas online',
        has_booking_platform: 'Plataforma de reservas',
        has_session_packs: 'Bonos de sesiones',
        has_group_classes: 'Clases grupales',
        has_schedule: 'Horario publicado',
        has_multiple_professionals: 'Varios profesionales',
        owner_visible: 'Dueño visible',
        has_cancellation_sensitive: 'Política de cancelación',
        is_franchise: 'Franquicia',
        is_ecommerce_only: 'Solo ecommerce',
        website_active: 'Web activa',
        has_instagram_link: 'Enlace a Instagram',
      },
    },
    errors: {
      session_expired: 'Tu sesión ha caducado. Inicia sesión de nuevo para continuar.',
      invalid_token: 'El token de acceso no es válido. Vuelve a iniciar sesión.',
      user_not_found: 'No hemos encontrado tu usuario. Verifica tus credenciales e inténtalo de nuevo.',
      insufficient_permissions: 'No tienes permisos para realizar esta acción. Pide acceso a un administrador si lo necesitas.',
      cross_center_access_denied: 'Esta acción afecta a otro centro y tu cuenta no tiene acceso. Contacta con el administrador del centro correspondiente.',
      account_not_linked: 'Tu cuenta de usuario aún no está vinculada a un cliente. Contacta con el centro para completar el alta.',
      slot_already_booked: 'Ese horario ya está reservado. Elige otro hueco disponible.',
      idempotency_key_payload_mismatch: 'Hubo un problema al enviar la solicitud. Recarga la página y vuelve a intentarlo.',
      duplicate_booking: 'Ya tienes una reserva idéntica registrada. No se ha duplicado la cita.',
      concurrent_modification: 'Otro usuario ha modificado estos datos mientras los editabas. Recarga la página y vuelve a intentarlo.',
      validation_error: 'Algunos datos no son válidos ({{field}}). Corrige los campos resaltados y vuelve a intentarlo.',
      date_format_error: 'La fecha introducida no tiene el formato esperado. Usa el formato AAAA-MM-DD.',
      rate_limit_exceeded: 'Has hecho demasiadas solicitudes en poco tiempo. Espera un momento antes de reintentar.',
      // R1.11 / D11 — `POST /clients/{id}/access` error codes.
      email_already_in_use: 'Este correo electrónico ya está en uso.',
      invalid_role_for_link: 'No se puede vincular este usuario a una ficha de cliente con su rol actual.',
      user_already_linked: 'Este usuario ya está vinculado a otra ficha.',
      client_not_found: 'No se ha encontrado la ficha de cliente.',
      transactions_unavailable: 'El sistema no puede completar la operación ahora. Inténtalo de nuevo en unos minutos.',
      http_401: 'No estás autenticado. Inicia sesión para continuar.',
      http_403: 'No tienes permisos para acceder a este recurso.',
      http_404: 'No hemos encontrado el recurso solicitado.',
      http_409: 'La solicitud entra en conflicto con el estado actual. Recarga y vuelve a intentarlo.',
      http_422: 'Los datos enviados no son válidos. Revisa los campos e inténtalo de nuevo.',
      http_429: 'Has hecho demasiadas solicitudes. Espera un momento antes de continuar.',
    },
    success: {
      placeholder: 'Operación completada correctamente.',
      layout: {
        waitlistConfirmed: 'Reserva confirmada desde lista de espera',
        waitlistConfirmTaken: 'Esa oferta ya no está disponible. Pide al cliente que elija otro hueco de la lista de espera.',
        notificationDeleteError: 'No se pudo eliminar la notificación',
        legalAcceptedSaaS: 'Contrato SaaS aceptado',
        legalAcceptedDpa: 'Anexo DPA aceptado',
        legalAcceptedPrivacy: 'Política de Privacidad aceptada',
        legalAcceptedTerms: 'Términos de uso aceptados',
        logoutError: 'No se pudo completar el cierre de sesión de forma segura',
        restoreSuperAdminError: 'No se pudo volver a SuperAdmin de forma segura',
      },
      whatsapp: {
        timeoutUpdateError: 'No se pudo actualizar el timeout de auto-return',
      },
      planner: {
        breakDeleted: 'Descanso eliminado',
        breakCreated: 'Descanso creado',
        selectVariantRequired: 'Selecciona una variante antes de crear la reserva.',
        staffUpdated: 'Personal actualizado',
        staffAssigned: 'Personal asignado',
        noCompatibleStaff: 'No hay personal compatible disponible. La reserva sigue pendiente.',
        bookingAlreadyHasStaff: 'La reserva ya tiene personal asignado.',
        noteSaved: 'Nota guardada',
        noteSaveError: 'Error al guardar la nota',
      },
      clientProfile: {
        planMonthlyCreated: 'Plan mensual creado y asignado al cliente',
        packNotIdentified: 'Error: no se pudo identificar el bono',
        planUpdated: 'Plan actualizado',
        planCancelled: 'Plan cancelado',
        recoveryDateRequired: 'Indica la fecha límite de recuperación',
        recoveryPackCreated: 'Bono de recuperación creado',
        consentRecorded: 'Consentimiento registrado',
        consentError: 'Error al registrar consentimiento',
        privacyRegistered: 'Política de privacidad registrada',
        termsRegistered: 'Términos de uso registrados',
      },
      whatsappDashboard: {
        statsLoadError: 'No se pudieron cargar las estadísticas de WhatsApp',
        configUpdateError: 'No se pudo actualizar la configuración',
      },
      staff: {
        scheduleSaved: 'Horario guardado',
      },
      centers: {
        websiteCreated: 'Configuración de web pública creada',
        websiteSaved: 'Web pública guardada',
        websiteActivated: 'Web pública activada',
        websiteDeactivated: 'Web pública desactivada',
        notFound: 'Centro no encontrado.',
        configSaved: 'Configuración guardada',
        invalidMinutes: 'Introduce un número de minutos válido',
        invalidCredits: 'Introduce un número de créditos válido',
        vapiSynced: 'Configuración Vapi guardada y sincronizada',
        whatsappUnlinked: 'WhatsApp desvinculado correctamente.',
      },
      notifications: {
        loadError: 'Error cargando notificaciones',
        markReadError: 'No se pudo marcar como leído',
        markedAllRead: 'Marcadas como leídas',
        markAllError: 'No se pudo marcar todo',
        deleted: 'Notificación eliminada',
        deleteError: 'No se pudo eliminar',
      },
      costDashboard: {
        subscriptionCreated: 'Suscripción creada',
        subscriptionUpdated: 'Suscripción actualizada',
        subscriptionCancelled: 'Suscripción cancelada',
        cancelError: 'Error al cancelar',
        loadError: 'Error al cargar el dashboard de costes',
        exportError: 'Error al exportar',
      },
      dashboard: {
        saasStatsError: 'Error al cargar estadísticas SaaS',
        aiSecretaryStatsError: 'Error al cargar estadísticas de Secretaria IA',
        exportKpisError: 'Error al exportar KPIs',
      },
      contentEngine: {
        draftsLoadError: 'No se pudieron cargar los borradores',
        draftSaved: 'Borrador guardado',
        editSaveError: 'No se pudo guardar la edición',
        mdxDownloaded: 'MDX descargado — colócalo en adamsched-web/content/blog/ en una rama y abre PR',
      },
      clients: {
        loadError: 'Error al cargar los clientes',
        archived: 'Cliente archivado',
        restored: 'Cliente restaurado',
        deleted: 'Cliente eliminado',
        nameRequired: 'El nombre es obligatorio',
        created: 'Cliente creado',
        createError: 'No se pudo crear el cliente',
      },
      settings: {
        aiSecretaryToggleError: 'Error al cambiar el estado de la secretaria IA',
        configUpdateError: 'Error al actualizar la configuración',
        saveError: 'Error al guardar',
      },
    },
  },

  en: {
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      loading: 'Loading...',
      noResults: 'No results',
      confirm: 'Confirm',
      back: 'Back',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      actions: 'Actions',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      reason: 'Reason',
      reasonRequired: 'Reason required',
    },
    auth: {
      login: 'Log In',
      logout: 'Log Out',
      email: 'Email',
      password: 'Password',
      loginTitle: 'AdamSched Fitness',
      loginSubtitle: 'Professional appointment management',
      invalidCredentials: 'Invalid credentials',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password',
      forgotPassword: 'Forgot your password?',
      forgotPasswordTitle: 'Recover password',
      forgotPasswordSubtitle: 'Enter your email and we will send you a link to reset your password.',
      sendResetLink: 'Send link',
      resetLinkSent: 'If the email exists in our system, you will receive a link shortly.',
      backToLogin: 'Back to login',
      resetPasswordTitle: 'Reset password',
      confirmPassword: 'Confirm password',
      passwordsDoNotMatch: 'Passwords do not match',
      resetPassword: 'Reset password',
      resetSuccess: 'Your password has been reset successfully. Redirecting to login...',
      resetInvalidToken: 'This link is invalid or has expired. Request a new one.',
      requestNewLink: 'Request a new link',
    },
    nav: {
      planner: 'Planner',
      clients: 'Clients',
      requests: 'Requests',
      services: 'Services',
      staff: 'Staff',
      settings: 'Settings',
      centers: 'Centers',
      auditLog: 'Audit Log',
      waitlist: 'Waitlist',
      notifications: 'Notifications',
      dashboard: 'Dashboard',
      myPacks: 'My packs',
      costs: 'Costs',
      whatsappInbox: 'WhatsApp',
    },
    dashboard: {
      title: 'Dashboard',
      loadError: 'Failed to load dashboard',
      noData: 'No data this week',
      allGood: 'All good',
      sessions: 'sessions',
      sessionsLeft: 'left',
      vsLastMonth: 'vs last month',
      outstanding: 'outstanding',
      sections: {
        occupancy: 'Occupancy & attendance',
        financial: 'Financial',
        alerts: 'Alerts',
      },
      occupancyWeek: 'Occupancy this week by service',
      attendanceMonth: 'Attendance this month',
      attended: 'Attended',
      noShow: 'No-shows',
      topClients: 'Top 5 most active clients',
      revenueMonth: 'Revenue this month',
      packsSold: 'Packs sold this month',
      pendingPayment: 'Pending payment',
      expiringSoon: 'Expiring in 30 days',
      debtClients: 'Clients in debt',
      lowSessions: 'Nearly depleted packs',
      saas: {
        allCentersActive: 'All active centres have recent activity',
        noBookings: 'no bookings',
        lastBooking: 'last:',
        daysAgo: '{{n}}d ago',
      },
    },
    planner: {
      title: 'Planner',
      today: 'Today',
      dayView: 'Day',
      weekView: 'Week',
      monthView: 'Month',
      addBooking: 'New booking',
      noBookings: 'No bookings',
      capacity: 'Capacity',
      selectClient: 'Select client',
      selectService: 'Select service',
      startTime: 'Start time',
      duration: 'Duration',
      minutes: 'minutes',
      slots: 'Slots',
      occupied: 'Busy',
      time: 'Time',
      break: 'Break',
      template: 'Template',
      applyTemplate: 'Apply template',
      apply: 'Apply',
      noTemplatesHint: 'No templates. Create one in Settings → Schedule.',
      bookingsCreated: 'bookings created',
      bookingsSkipped: '{{n}} skipped (already existed)',
      breaksRegistered: '{{n}} break(s) registered',
      toast: {
        loadError: 'Error loading data',
        statusUpdated: 'Status updated',
        statusError: 'Failed to update status',
        bookingDeleted: 'Booking deleted',
        bookingDeleteError: 'Failed to delete booking',
        applyTemplateError: 'Error applying template',
      },
    },
    bookings: {
      title: 'Bookings',
      status: {
        reserved: 'Reserved',
        attended: 'Attended',
        noShow: 'No Show',
        no_show: 'No-show',
        cancelled: 'Cancelled',
      },
      assignedStaff: 'Staff',
      markAttended: 'Mark attended',
      markNoShow: 'Mark no show',
      noShowReason: 'No show reason',
      noShowReasonRequired: 'Reason is required',
      moveBooking: 'Booking moved',
      deleteConfirm: 'Delete this booking?',
      capacityExceeded: 'Capacity exceeded for this time slot',
      clientOverlap: 'Client already has a booking at this time',
      created: 'Booking created',
      debtWarning: 'Booking without paid pack',
      debtNote: 'Client has no active session pack. This booking counts toward debt limit.',
    },
    clients: {
      title: 'Clients',
      addClient: 'New client',
      fullName: 'First name',
      surname: 'Surname',
      phone: 'Phone',
      notes: 'Internal notes',
      bookingHistory: 'Booking history',
      sessionPacks: 'Session packs',
      noClients: 'No clients',
      archived: 'Client archived',
      deleted: 'Client deleted',
    },
    sessionPacks: {
      title: 'Session packs',
      addPack: 'New pack',
      totalSessions: 'Total sessions',
      remainingSessions: 'Remaining sessions',
      price: 'Price',
      noPacks: 'No active packs',
      sessionsRemaining: 'sessions remaining',
      selectService: 'Select service',
      created: 'Pack created',
      status: 'Status',
      pendingPayment: 'Pending payment',
      paymentMethod: 'Payment method',
      selectPaymentMethod: 'Select payment method',
      cash: 'Cash',
      card: 'Card',
      confirmDelete: 'Delete pack',
      deleteRequiresReason: 'You must provide a reason. It will be recorded in the audit log.',
      expiresAt: 'Expiry date (optional)',
      updated: 'Pack updated',
      deleted: 'Pack deleted',
      hasBookings: 'This pack has associated bookings and cannot be deleted. Would you like to deactivate it instead?',
      deactivateTitle: 'Deactivate pack?',
      deactivate: 'Deactivate pack',
      deactivated: 'Pack deactivated',
      allServices: 'All services',
    },
    services: {
      title: 'Services',
      addService: 'New service',
      name: 'Name',
      color: 'Color',
      capacity: 'Capacity per slot',
      defaultDuration: 'Default duration',
      slotsPerBooking: 'Slots per booking',
      slots: 'slots',
      noServices: 'No services',
      created: 'Service created',
      updated: 'Service updated',
      manageServices: 'Manage services',
      toast: {
        loadError: 'Error loading services',
        nameRequired: 'Name is required',
        saveError: 'Failed to save service',
        confirmDelete: 'Delete "{{name}}"?',
        deleted: 'Service deleted',
        deleteError: 'Failed to delete service',
      },
    },
    requests: {
      title: 'Requests',
      addRequest: 'New request',
      rawText: 'Original text',
      detectedInfo: 'Detected info',
      convertToBooking: 'Convert to booking',
      dismiss: 'Dismiss',
      status: {
        pending: 'Pending',
        converted: 'Resolved',
        dismissed: 'Dismissed',
      },
      noRequests: 'No pending requests',
      noResults: 'No results for that search',
      processed: 'Processed',
      fields: {
        name: 'Name',
        phone: 'Phone',
        service: 'Service',
        dateTime: 'Date/Time',
      },
      toast: {
        loadError: 'Error loading requests',
        textRequired: 'Text is required',
        created: 'Request created',
        createError: 'Failed to create request',
        updated: 'Request updated',
        updateError: 'Failed to update request',
      },
    },
    staff: {
      title: 'Staff',
      addStaff: 'New user',
      role: 'Role',
      userCreated: 'User created',
      userUpdated: 'User updated',
      clientNote: 'A client profile will be automatically created and linked to this account.',
      roles: {
        superAdmin: 'Super Admin',
        centerAdmin: 'Center Admin',
        staff: 'Staff',
        client: 'Client',
      },
      noUsers: 'No users found',
      toast: {
        loadError: 'Error loading users',
        emailNameRequired: 'Email and name are required',
        passwordRequired: 'Password is required for new users',
        clientAlreadyHasAccess: 'This client already has access (a linked user already exists).',
        saveError: 'Failed to save user',
        confirmDelete: 'Delete "{{name}}"?',
        deleted: 'User deleted',
        deleteError: 'Failed to delete user',
      },
    },
    centers: {
      title: 'Centers',
      addCenter: 'New center',
      name: 'Name',
      timezone: 'Timezone',
      openingTime: 'Opening time',
      closingTime: 'Closing time',
      slotDuration: 'Slot duration',
      centerDetails: 'Center details',
      centerAdmin: 'Center admin',
      adminName: 'Admin name',
      adminEmailRequired: 'Admin email is required',
      adminPasswordRequired: 'Admin password required (min 6 chars)',
      adminNote: 'This admin will only have access to this center.',
      noBilling: 'Non-billed center (demo/courtesy)',
      noBillingHelp: 'It will not be billed. The subscription is created with FREE status and excluded from monthly billing.',
      whatsappManagedElsewhere: 'WhatsApp credentials are configured from the "WhatsApp" tab (WhatsApp provisioning).',
      created: 'Center created with admin',
      updated: 'Center updated',
      noCenters: 'No centers',
      nameRequired: 'Name is required',
      manageCenters: 'Manage centers',
      deactivate: 'Deactivate',
      reactivate: 'Reactivate',
      deleteHard: 'Permanently delete',
      resetPassword: 'Reset password',
      exportClients: 'Export clients CSV',
      exportClientsLoading: 'Exporting clients CSV...',
      fichaClientTitle: 'Client profile (configurable per center)',
      fichaLabel: 'Profile sections',
      fichaTip: 'Enable/disable with the checkbox and reorder with the arrows.',
      rgpdLegalText: 'Default GDPR legal text',
      whatsappTitle: 'WhatsApp Business (per center)',
      metaAccessToken: 'Meta Access Token',
      phoneNumberId: 'Phone Number ID',
      moveUp: 'Move up',
      moveDown: 'Move down',
      whatsapp: {
        statusLabel: 'WhatsApp Status',
        provisionBtn: 'Provision WhatsApp',
        refreshStatus: 'Refresh status',
        status: {
          notConnected: 'Not connected',
          pendingReview: 'Pending review',
          pendingRegistration: 'Pending registration',
          registering: 'Registering...',
          active: 'Active',
          failed: 'Failed',
          rateLimited: 'Rate limited',
        },
        provision: {
          title: 'Connect WhatsApp Business',
          accessToken: 'Meta Access Token',
          wabaId: 'WABA ID',
          phoneNumberId: 'Phone Number ID',
          pin: 'PIN (6 digits)',
          pinHelp: 'PIN that protects the number in the Cloud API. Required for re-registration.',
          displayName: 'Display name (optional)',
          submit: 'Provision manually',
          connectWithFacebook: 'Connect with Facebook',
          embeddedSignupHint: "Opens Meta's assistant to link this centre's WABA.",
          orManual: 'Or enter the data manually',
        },
        toast: {
          provisionSuccess: 'WhatsApp provisioned successfully',
          provisionError: 'Error provisioning WhatsApp',
          statusRefreshed: 'Status updated',
          statusError: 'Error fetching WhatsApp status',
          sdkNotLoaded: 'Facebook SDK not available. Reload the page.',
          signupCancelled: 'Signup cancelled',
          noWabaData: 'No WABA data received — use the manual form',
        },
        guide: {
          step1: { title: 'Open Meta Business Manager', text: 'Go to business.facebook.com → WhatsApp Accounts', btn: 'Open Meta Business' },
          step2: { title: "Create the centre's WhatsApp account", text: 'Click + Add → Create new account → enter the centre name' },
          step3: { title: 'Add the phone number', text: 'In the created account → Phone Numbers → Add number → enter the centre number. The client will receive an SMS with the verification code.' },
          step4: { title: 'Copy the Phone Number ID', text: 'WhatsApp Manager → select the number → copy the Phone Number Identifier' },
          step5: { title: 'Copy the WABA ID', text: 'In the WhatsApp account → copy the Identifier' },
          step6: { title: 'Set a security PIN' },
          connectBtn: 'Connect WhatsApp',
        },
      },
      toast: {
        loadError: 'Error loading centers',
        passwordReset: 'Password reset',
        passwordResetError: 'Could not reset password',
        confirmResetPassword: 'Reset {{label}} password?\n\nA temporary password will be generated and displayed to copy.',
        confirmDeactivate: 'Deactivate this center?',
        deactivated: 'Center deactivated',
        deactivateError: 'Error deactivating center',
        reactivated: 'Center reactivated',
        reactivateError: 'Error reactivating center',
        exportClientsError: 'Error exporting clients CSV',
        confirmDeleteHard: 'Permanently delete this center? Only possible if it has no associated data.',
        deleted: 'Center deleted',
        cannotDelete: 'Cannot delete: there is associated data. Deactivate the center instead.',
      },
    },
    settings: {
      title: 'Settings',
      centerSettings: 'Center settings',
      language: 'Language',
      profile: 'Profile',
      connect: {
        title: 'Stripe Connect',
        description: 'Link your center Stripe account through secure onboarding.',
        status: 'Status',
        action: 'Enable / continue onboarding',
        requirements: 'Review requirements',
        error: 'Stripe Connect could not be started',
      },
      tabs: {
        general: 'General',
        center: 'Center',
        schedule: 'Schedule',
      },
      cancelRules: {
        title: 'Cancellation rules',
        rule: 'Rule',
        dayBefore: 'Day before',
        sameDay: 'Same day',
        cutoffDayBefore: 'Cutoff time (day before)',
        cutoffSameDay: 'Cutoff time (same day)',
        note: 'Outside rule: marked NO_SHOW, session deducted / debt generated.',
      },
      weeklySchedule: {
        title: 'Weekly Schedule',
        noTemplates: 'No templates',
        newTemplate: 'New template',
        editTemplate: 'Edit template',
        breaks: 'Breaks',
        noBreaks: 'No breaks',
        slots: 'Slots',
        noSlots: 'No slots',
        add: 'Add',
        nameLabel: 'Name',
        namePlaceholder: 'E.g.: Week type A',
        clients: 'Clients',
        searchClient: 'Search client...',
        editorDescription: 'Weekly template editor',
        // template-service-break-semantics (Hallazgo 5, task 9.1.1):
        // placeholders del editor de breaks de plantilla (Settings.js).
        breakGlobal: 'Global (whole slot)',
        breakAllVariants: 'All variants',
        // template-service-break-semantics (Hallazgo 6, task 9.3.1).
        breakFrom: 'From',
        breakTo: 'To',
      },
      days: {
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
      },
      toast: {
        loadTemplatesError: 'Error loading templates',
        saveError: 'Error saving settings',
        saveTemplateError: 'Error saving template',
        deleteTemplateError: 'Error deleting template',
        templateNameRequired: 'Name is required',
        templateSaved: 'Template saved',
        templateDeleted: 'Template deleted',
        confirmDeleteTemplate: 'Delete template "{{name}}"?',
        // template-service-break-semantics (Hallazgo 6, task 9.3.1).
        breakTimeRequired: 'Specify the start and end times of each break before saving',
      },
    },
    auditLog: {
      title: 'Audit Log',
      user: 'User',
      action: 'Action',
      entity: 'Entity',
      timestamp: 'Timestamp',
      details: 'Details',
      detailMessages: {
        createdBooking: 'Booking created for {{client}} - {{service}}',
        deletedBooking: 'Booking deleted',
      },
      actions: {
        create: 'Created',
        update: 'Updated',
        delete: 'Deleted',
        deduct: 'Deducted',
        apply: 'Template applied',
      },
      entities: {
        booking: 'Booking',
        client: 'Client',
        user: 'User',
        center: 'Center',
        calendar: 'Service',
        session_pack: 'Session pack',
        request: 'Request',
        waitlist: 'Waitlist',
        weekly_template: 'Weekly template',
        unknown: 'Other',
      },
      empty: 'No audit logs found',
      loadError: 'Error loading audit logs',
    },
    time: {
      today: 'Today',
      yesterday: 'Yesterday',
      tomorrow: 'Tomorrow',
    },
    layout: {
      notifications: {
        markAllRead: 'Mark all read',
        markRead: 'Mark read',
        empty: 'No notifications',
        open: 'Open',
      },
      waitlistOffer: {
        title: 'Spot available — waitlist',
        body: 'A spot has been freed by a cancellation and offered to the first client on the waitlist.',
        clientLabel: 'Client',
        serviceLabel: 'Service',
        slotLabel: 'Slot',
        confirmBtn: 'OK — Confirm',
      },
    },
    waitlist: {
      title: 'Waitlist',
      newRequest: 'New request',
      cancelConfirm: 'Cancel this waitlist entry?',
      clientSelected: 'Client selected',
      searchClient: 'Type and choose a client',
      searchClientPlaceholder: 'Client (search by name)',
      selectService: 'Service',
      selectDay: 'Select a day',
      timeCarousel: 'Time (carousel or type)',
      noEntries: 'No waitlist entries.',
      position: 'Position {{n}} in the list',
      cancelRequest: 'Cancel request',
      force: 'Force',
      columns: {
        client: 'Client',
        service: 'Service',
        slot: 'Slot',
      },
      status: {
        waiting: 'Waiting',
        offered: 'Offered',
        confirmed: 'Confirmed',
        expired: 'Expired',
        cancelled: 'Cancelled',
      },
      toast: {
        loadError: 'Error loading waitlist',
        created: 'Entry created',
        forced: 'Forced',
        cancelled: 'Cancelled',
        bookingConfirmed: 'Booking confirmed from waitlist',
        fillRequired: 'Fill in client, service and date/time',
        cannotClose: 'Could not close the notice',
        cannotConfirm: 'Could not confirm the offer',
        cannotForce: 'Could not force',
        cannotCancel: 'Could not cancel',
        cannotCreate: 'Could not create',
      },
    },
    clientProfile: {
      access: {
        title: 'Personal area access',
        enabled: 'Enabled',
        disabled: 'Disabled',
        resetPassword: 'Reset password',
        disableAccess: 'Disable access',
        enableAccess: 'Enable access',
        dialogTitleReset: 'Reset access',
        dialogTitleEnable: 'Enable access',
        emailLabel: 'Email *',
        passwordLabel: 'Password *',
        adminNote: 'The admin sets a new password, sees it on screen, and communicates it to the client.',
      },
      tabs: {
        ficha: 'Profile',
        personal: 'Staff',
      },
      personal: {
        loading: 'Loading staff…',
        emptyStaff: 'No active staff',
        error: 'Could not load staff',
      },
      sections: {
        personalData: 'Personal data',
        rgpd: 'GDPR',
      },
      fields: {
        firstName: 'First name',
        surname: 'Surname',
        phone: 'Phone',
        email: 'Email',
        birthDate: 'Date of birth',
        professionalSector: 'Professional sector',
        address: 'Address (optional)',
        legalText: 'Legal text (stored on the client record)',
      },
      rgpd: {
        consent: 'GDPR consent',
        dateLabel: 'Date:',
      },
      toast: {
        loadError: 'Error loading client',
        updated: 'Client updated',
        updateError: 'Failed to update client',
        emailPasswordRequired: 'Email and password are required',
        passwordUpdated: 'Password updated',
        accessCreated: 'Access created',
        accessReactivated: 'Access reactivated',
        accessError: 'Could not save access',
        accessDisabled: 'Access disabled',
        accessDisableError: 'Could not disable access',
      },
    },

    contentEngine: {
      nav: 'Content Engine',
    },
    aiLeadScanner: {
      nav: 'Lead Scanner',
      title: 'AI Lead Scanner',
      todayFollowUps: {
        title: "Today's follow-ups",
        empty: 'No follow-ups pending for today',
        overdueLabel: 'Overdue',
      },
      activeFollowUps: {
        title: 'Active follow-ups',
        empty: 'No active follow-ups',
      },
      discardSuggestions: {
        title: 'Discard suggestions',
        empty: 'No lead has reached the follow-up limit',
      },
      filters: {
        sector: 'Sector',
        city: 'City',
        priority: 'Priority',
        status: 'Status',
        temperature: 'Temperature',
        minScore: 'Minimum score',
        search: 'Search by name',
        searchPlaceholder: 'Business name...',
        allSectors: 'All sectors',
        allPriorities: 'All priorities',
        allStatuses: 'All statuses',
        allTemperatures: 'All',
        clear: 'Clear filters',
      },
      table: {
        businessName: 'Business',
        sector: 'Sector',
        city: 'City',
        score: 'Score',
        priority: 'Priority',
        status: 'Status',
        temperature: 'Temp.',
        lastContacted: 'Last contacted',
        nextFollowUp: 'Next follow-up',
        actions: 'Actions',
        noLeads: 'No leads match these filters',
        viewDetail: 'View profile',
        never: '—',
        loadError: 'Could not load leads',
      },
      actions: {
        addLead: 'Add lead',
        importExcel: 'Import Excel',
        analyzeSelected: 'Analyze selected',
        discardSelected: 'Discard selected',
      },
      discardDialog: {
        title: 'Discard {{count}} lead(s)?',
        description: 'You can find them later by filtering by "Discarded" status. This is not a real deletion — the lead still exists, only its status changes.',
        confirm: 'Discard',
      },
      addLeadModal: {
        businessName: 'Business name',
        businessNameRequired: 'Business name is required',
        province: 'Province',
        phone: 'Phone',
        email: 'Email',
        create: 'Create lead',
        success: 'Lead created successfully',
        error: 'Could not create lead',
        duplicateReasonDomain: 'A lead with this same website already exists: {{name}}',
        duplicateReasonPhone: 'A lead with this same phone number already exists: {{name}}',
        duplicateReasonNameCity: 'A lead with the same name and city already exists: {{name}}',
        viewExisting: 'View existing lead',
      },
      importModal: {
        runDryRun: 'Analyze file',
        totalRows: 'Total rows',
        imported: 'Would be imported',
        duplicates: 'Duplicates',
        invalidRows: 'Invalid rows (missing business name)',
        contactadoDefaultedWhatsapp: '"Contacted" status — channel defaulted to WhatsApp',
        followUpNoDate: 'Follow-up without a date',
        addressUnparsed: 'Address could not be parsed',
        unrecognizedStatuses: 'Unrecognized statuses',
        rowRef: 'Sheet {{sheet}}, row {{row}}',
        confirmWarning: 'This will write the real leads to the database. Review the summary before confirming.',
        confirmImport: 'Confirm import',
        success: '{{count}} leads imported successfully',
        error: 'Could not complete the import',
      },
      pagination: {
        showing: 'Showing {{from}}–{{to}} of {{total}}',
        previous: 'Previous',
        next: 'Next',
      },
      calendar: {
        title: 'Follow-up calendar',
      },
      status: {
        NEW: 'New',
        READY_TO_CONTACT: 'Ready to contact',
        CONTACTED_WHATSAPP: 'Contacted (WhatsApp)',
        CONTACTED_EMAIL: 'Contacted (Email)',
        CONTACTED_CALL: 'Contacted (Call)',
        FOLLOW_UP: 'Follow-up',
        DEMO_PENDING: 'Demo pending',
        DEMO_SCHEDULED: 'Demo scheduled',
        EVALUATING_PROPOSAL: 'Evaluating proposal',
        CUSTOMER: 'Customer',
        NOT_INTERESTED: 'Not interested',
        DISCARDED: 'Discarded',
        ERROR: 'Error',
      },
      priority: {
        high: 'High',
        medium: 'Medium',
        low: 'Low',
        discard: 'Discard',
        unknown: 'Unscored',
      },
      temperature: {
        HOT: 'Hot',
        WARM: 'Warm',
        COLD: 'Cold',
      },
      sector: {
        personal_trainer: 'Personal trainer',
        small_gym: 'Small gym',
        functional_training: 'Functional training',
        boutique_gym: 'Boutique gym',
        cross_training: 'Cross training',
        pilates: 'Pilates',
        yoga: 'Yoga',
        physiotherapy: 'Physiotherapy',
        osteopathy: 'Osteopathy',
        nutritionist: 'Nutrition',
        psychologist: 'Psychology',
        massage_therapist: 'Massage therapist',
        manual_therapist: 'Manual therapist',
        wellness_center: 'Wellness center',
        chiropractor: 'Chiropractor',
        unknown: 'Undefined',
      },
      leadDetail: {
        back: 'Back',
        profile: 'Profile',
        address: 'Address',
        website: 'Website',
        instagram: 'Instagram',
        notes: 'Notes',
        needsWebsite: 'No own website',
        loadError: 'Could not load lead',
        notFound: 'Lead not found',
        markContacted: 'Mark contacted',
        markContactedWhatsapp: 'Via WhatsApp',
        markContactedEmail: 'Via email',
        markContactedCall: 'Via call',
        changeStatus: 'Change status',
        markDiscard: 'Discard',
        followUpCount: 'Follow-ups: {{count}}/{{limit}}',
        discardSuggestionDescription: 'This lead has reached the limit of {{limit}} follow-ups without moving forward. You can discard it or keep trying manually.',
        pasteManualContent: 'Paste website content manually',
        pasteManualContentTitle: 'Paste website content manually',
        pasteManualContentDescription: 'The automatic website analysis failed while trying to access it. Paste here the text you copy yourself from the browser — the rest of the analysis (sector, signals, score, messages) is generated the same way as always from that text.',
        pasteManualContentLabel: 'Website content',
        markFollowUp: 'Set follow-up',
        followUpDate: 'Follow-up date',
        followUpNote: 'Note (optional)',
        markNotInterested: 'Not interested',
        regenerateMessages: 'Regenerate messages',
        reanalyze: 'Re-analyze',
        actionSuccess: 'Done',
        actionError: 'Could not complete the action',
        noAnalysisYet: 'This lead has no analysis yet. Use "Re-analyze" to generate one.',
        noMessagesYet: 'This lead has no generated messages yet.',
        save: 'Save',
        cancel: 'Cancel',
        edit: 'Edit',
      },
      editLeadModal: {
        title: 'Edit lead',
        success: 'Lead updated successfully',
        error: 'Could not update lead',
      },
      messageCard: {
        copy: 'Copy',
        copied: 'Copied to clipboard',
        copyError: 'Could not copy',
        words: 'words',
        subject: 'Subject',
        exceedsLimit: 'Exceeds the recommended 180-word limit, review before copying',
        whatsappInitial: 'Initial WhatsApp',
        emailInitial: 'Initial email',
        followUp1: 'Follow-up 1',
        followUp2: 'Follow-up 2',
        callScript: 'Call script',
        internalNotes: 'Internal notes',
      },
      scoreBreakdown: {
        positive: 'Positive signals',
        negative: 'Negative signals',
      },
      websiteAnalysis: {
        title: 'Website analysis',
        confidence: 'Confidence',
        excluded: 'Excluded',
        detectedSector: 'Detected sector',
        evidence: 'Evidence',
      },
      signals: {
        has_whatsapp: 'WhatsApp visible',
        has_online_booking: 'Online booking',
        has_booking_platform: 'Booking platform',
        has_session_packs: 'Session packs',
        has_group_classes: 'Group classes',
        has_schedule: 'Published schedule',
        has_multiple_professionals: 'Multiple professionals',
        owner_visible: 'Owner visible',
        has_cancellation_sensitive: 'Cancellation policy',
        is_franchise: 'Franchise',
        is_ecommerce_only: 'Ecommerce only',
        website_active: 'Active website',
        has_instagram_link: 'Instagram link',
      },
    },
    errors: {
      session_expired: 'Your session has expired. Sign in again to continue.',
      invalid_token: 'The access token is not valid. Please sign in again.',
      user_not_found: 'We could not find your user. Check your credentials and try again.',
      insufficient_permissions: 'You do not have permission to perform this action. Ask an administrator if you need access.',
      cross_center_access_denied: 'This action affects another center and your account has no access. Contact the corresponding center administrator.',
      account_not_linked: 'Your user account is not linked to a client yet. Contact the center to complete your registration.',
      slot_already_booked: 'That time slot is already booked. Choose another available slot.',
      idempotency_key_payload_mismatch: 'There was a problem sending your request. Reload the page and try again.',
      duplicate_booking: 'You already have an identical booking registered. The appointment has not been duplicated.',
      concurrent_modification: 'Another user modified this data while you were editing. Reload the page and try again.',
      validation_error: 'Some data is invalid ({{field}}). Correct the highlighted fields and try again.',
      date_format_error: 'The entered date is not in the expected format. Use YYYY-MM-DD.',
      rate_limit_exceeded: 'You have made too many requests in a short time. Wait a moment before retrying.',
      // R1.11 / D11 — `POST /clients/{id}/access` error codes.
      email_already_in_use: 'This email address is already in use.',
      invalid_role_for_link: 'This user cannot be linked to a client profile with their current role.',
      user_already_linked: 'This user is already linked to another client profile.',
      client_not_found: 'The client profile could not be found.',
      transactions_unavailable: 'The system cannot complete the operation right now. Please try again in a few minutes.',
      http_401: 'You are not authenticated. Sign in to continue.',
      http_403: 'You do not have permission to access this resource.',
      http_404: 'The requested resource was not found.',
      http_409: 'The request conflicts with the current state. Reload and try again.',
      http_422: 'The submitted data is not valid. Check the fields and try again.',
      http_429: 'You have made too many requests. Wait a moment before continuing.',
    },
    success: {
      placeholder: 'Operation completed successfully.',
      layout: {
        waitlistConfirmed: 'Booking confirmed from waitlist',
        waitlistConfirmTaken: 'That offer is no longer available. Ask the client to pick another waitlist slot.',
        notificationDeleteError: 'Could not delete the notification',
        legalAcceptedSaaS: 'SaaS contract accepted',
        legalAcceptedDpa: 'DPA addendum accepted',
        legalAcceptedPrivacy: 'Privacy policy accepted',
        legalAcceptedTerms: 'Terms of use accepted',
        logoutError: 'Could not complete the logout securely',
        restoreSuperAdminError: 'Could not return to SuperAdmin securely',
      },
      whatsapp: {
        timeoutUpdateError: 'Could not update the auto-return timeout',
      },
      planner: {
        breakDeleted: 'Break deleted',
        breakCreated: 'Break created',
        selectVariantRequired: 'Select a variant before creating the booking.',
        staffUpdated: 'Staff updated',
        staffAssigned: 'Staff assigned',
        noCompatibleStaff: 'No compatible staff available. The booking remains pending.',
        bookingAlreadyHasStaff: 'This booking already has staff assigned.',
        noteSaved: 'Note saved',
        noteSaveError: 'Error saving the note',
      },
      clientProfile: {
        planMonthlyCreated: 'Monthly plan created and assigned to the client',
        packNotIdentified: 'Error: could not identify the pack',
        planUpdated: 'Plan updated',
        planCancelled: 'Plan cancelled',
        recoveryDateRequired: 'Enter the recovery deadline',
        recoveryPackCreated: 'Recovery pack created',
        consentRecorded: 'Consent recorded',
        consentError: 'Error recording consent',
        privacyRegistered: 'Privacy policy recorded',
        termsRegistered: 'Terms of use recorded',
      },
      whatsappDashboard: {
        statsLoadError: 'Could not load WhatsApp statistics',
        configUpdateError: 'Could not update the configuration',
      },
      staff: {
        scheduleSaved: 'Schedule saved',
      },
      centers: {
        websiteCreated: 'Public website configuration created',
        websiteSaved: 'Public website saved',
        websiteActivated: 'Public website activated',
        websiteDeactivated: 'Public website deactivated',
        notFound: 'Center not found.',
        configSaved: 'Configuration saved',
        invalidMinutes: 'Enter a valid number of minutes',
        invalidCredits: 'Enter a valid number of credits',
        vapiSynced: 'Vapi configuration saved and synced',
        whatsappUnlinked: 'WhatsApp unlinked successfully.',
      },
      notifications: {
        loadError: 'Error loading notifications',
        markReadError: 'Could not mark as read',
        markedAllRead: 'Marked as read',
        markAllError: 'Could not mark all',
        deleted: 'Notification deleted',
        deleteError: 'Could not delete',
      },
      costDashboard: {
        subscriptionCreated: 'Subscription created',
        subscriptionUpdated: 'Subscription updated',
        subscriptionCancelled: 'Subscription cancelled',
        cancelError: 'Error cancelling',
        loadError: 'Error loading the cost dashboard',
        exportError: 'Error exporting',
      },
      dashboard: {
        saasStatsError: 'Error loading SaaS statistics',
        aiSecretaryStatsError: 'Error loading AI Secretary statistics',
        exportKpisError: 'Error exporting KPIs',
      },
      contentEngine: {
        draftsLoadError: 'Could not load drafts',
        draftSaved: 'Draft saved',
        editSaveError: 'Could not save the edit',
        mdxDownloaded: 'MDX downloaded — place it in adamsched-web/content/blog/ in a branch and open a PR',
      },
      clients: {
        loadError: 'Error loading clients',
        archived: 'Client archived',
        restored: 'Client restored',
        deleted: 'Client deleted',
        nameRequired: 'Name is required',
        created: 'Client created',
        createError: 'Failed to create client',
      },
      settings: {
        aiSecretaryToggleError: 'Error toggling the AI Secretary state',
        configUpdateError: 'Error updating the configuration',
        saveError: 'Error saving',
      },
    },
  },

  de: {
    common: {
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      create: 'Erstellen',
      search: 'Suchen',
      loading: 'Wird geladen...',
      noResults: 'Keine Ergebnisse',
      confirm: 'Bestätigen',
      back: 'Zurück',
      close: 'Schließen',
      yes: 'Ja',
      no: 'Nein',
      actions: 'Aktionen',
      status: 'Status',
      active: 'Aktiv',
      inactive: 'Inaktiv',
      reason: 'Grund',
      reasonRequired: 'Grund erforderlich',
    },
    auth: {
      login: 'Anmelden',
      logout: 'Abmelden',
      email: 'E-Mail',
      password: 'Passwort',
      loginTitle: 'AdamSched Fitness',
      loginSubtitle: 'Professionelle Terminverwaltung',
      invalidCredentials: 'Ungültige Anmeldedaten',
      changePassword: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      forgotPassword: 'Passwort vergessen?',
      forgotPasswordTitle: 'Passwort wiederherstellen',
      forgotPasswordSubtitle: 'Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.',
      sendResetLink: 'Link senden',
      resetLinkSent: 'Falls die E-Mail in unserem System existiert, erhältst du in Kürze einen Link.',
      backToLogin: 'Zurück zur Anmeldung',
      resetPasswordTitle: 'Passwort zurücksetzen',
      confirmPassword: 'Passwort bestätigen',
      passwordsDoNotMatch: 'Die Passwörter stimmen nicht überein',
      resetPassword: 'Passwort zurücksetzen',
      resetSuccess: 'Dein Passwort wurde erfolgreich zurückgesetzt. Weiterleitung zur Anmeldung...',
      resetInvalidToken: 'Dieser Link ist ungültig oder abgelaufen. Fordere einen neuen an.',
      requestNewLink: 'Neuen Link anfordern',
    },
    nav: {
      planner: 'Planer',
      clients: 'Kunden',
      requests: 'Anfragen',
      services: 'Dienste',
      staff: 'Personal',
      settings: 'Einstellungen',
      centers: 'Zentren',
      auditLog: 'Prüfprotokoll',
      waitlist: 'Warteliste',
      notifications: 'Benachrichtigungen',
      dashboard: 'Dashboard',
      myPacks: 'Meine Pakete',
      costs: 'Kosten',
      whatsappInbox: 'WhatsApp',
    },
    dashboard: {
      title: 'Dashboard',
      loadError: 'Fehler beim Laden des Dashboards',
      noData: 'Keine Daten diese Woche',
      allGood: 'Alles in Ordnung',
      sessions: 'Sitzungen',
      sessionsLeft: 'verbleibend',
      vsLastMonth: 'vs. letzten Monat',
      outstanding: 'ausstehend',
      sections: {
        occupancy: 'Auslastung und Teilnahme',
        financial: 'Finanziell',
        alerts: 'Warnungen',
      },
      occupancyWeek: 'Auslastung diese Woche nach Dienst',
      attendanceMonth: 'Teilnahme diesen Monat',
      attended: 'Teilgenommen',
      noShow: 'Nicht erschienen',
      topClients: 'Top 5 aktivste Kunden',
      revenueMonth: 'Einnahmen diesen Monat',
      packsSold: 'Pakete diesen Monat verkauft',
      pendingPayment: 'Ausstehende Zahlung',
      expiringSoon: 'Läuft in 30 Tagen ab',
      debtClients: 'Kunden mit Schulden',
      lowSessions: 'Fast aufgebrauchte Pakete',
      saas: {
        allCentersActive: 'Alle aktiven Zentren haben aktuelle Aktivität',
        noBookings: 'keine Buchungen',
        lastBooking: 'letzte:',
        daysAgo: 'vor {{n}} T.',
      },
    },
    planner: {
      title: 'Planer',
      today: 'Heute',
      dayView: 'Tag',
      weekView: 'Woche',
      monthView: 'Monat',
      addBooking: 'Neue Buchung',
      noBookings: 'Keine Buchungen',
      capacity: 'Kapazität',
      selectClient: 'Kunden auswählen',
      selectService: 'Dienst auswählen',
      startTime: 'Startzeit',
      duration: 'Dauer',
      minutes: 'Minuten',
      slots: 'Slots',
      occupied: 'Belegt',
      time: 'Uhrzeit',
      break: 'Pause',
      template: 'Vorlage',
      applyTemplate: 'Vorlage anwenden',
      apply: 'Anwenden',
      noTemplatesHint: 'Keine Vorlagen. Erstelle eine in Einstellungen → Zeitplan.',
      bookingsCreated: 'Buchungen erstellt',
      bookingsSkipped: '{{n}} übersprungen (bereits vorhanden)',
      breaksRegistered: '{{n}} Pause(n) registriert',
      toast: {
        loadError: 'Fehler beim Laden der Daten',
        statusUpdated: 'Status aktualisiert',
        statusError: 'Fehler beim Aktualisieren des Status',
        bookingDeleted: 'Buchung gelöscht',
        bookingDeleteError: 'Fehler beim Löschen der Buchung',
        applyTemplateError: 'Fehler beim Anwenden der Vorlage',
      },
    },
    bookings: {
      title: 'Buchungen',
      status: {
        reserved: 'Reserviert',
        attended: 'Teilgenommen',
        noShow: 'Nicht erschienen',
        no_show: 'Nicht erschienen',
        cancelled: 'Storniert',
      },
      assignedStaff: 'Personal',
      markAttended: 'Teilnahme vermerken',
      markNoShow: 'Nichterscheinen vermerken',
      noShowReason: 'Grund für Nichterscheinen',
      noShowReasonRequired: 'Grund ist erforderlich',
      moveBooking: 'Buchung verschoben',
      deleteConfirm: 'Diese Buchung löschen?',
      capacityExceeded: 'Kapazität für diesen Zeitslot überschritten',
      clientOverlap: 'Kunde hat bereits eine Buchung zu dieser Zeit',
      created: 'Buchung erstellt',
      debtWarning: 'Buchung ohne bezahltes Paket',
      debtNote: 'Kunde hat kein aktives Sitzungspaket. Diese Buchung zählt zum Schuldenlimit.',
    },
    clients: {
      title: 'Kunden',
      addClient: 'Neuer Kunde',
      fullName: 'Vorname',
      surname: 'Nachname',
      phone: 'Telefon',
      notes: 'Interne Notizen',
      bookingHistory: 'Buchungsverlauf',
      sessionPacks: 'Sitzungspakete',
      noClients: 'Keine Kunden',
      archived: 'Kunde archiviert',
      deleted: 'Kunde gelöscht',
    },
    sessionPacks: {
      title: 'Sitzungspakete',
      addPack: 'Neues Paket',
      totalSessions: 'Sitzungen gesamt',
      remainingSessions: 'Verbleibende Sitzungen',
      price: 'Preis',
      noPacks: 'Keine aktiven Pakete',
      sessionsRemaining: 'Sitzungen verbleibend',
      selectService: 'Dienst auswählen',
      created: 'Paket erstellt',
      status: 'Status',
      pendingPayment: 'Zahlung ausstehend',
      paymentMethod: 'Zahlungsmethode',
      selectPaymentMethod: 'Zahlungsmethode auswählen',
      cash: 'Bargeld',
      card: 'Karte',
      confirmDelete: 'Paket löschen',
      deleteRequiresReason: 'Du musst einen Grund angeben. Er wird im Prüfprotokoll erfasst.',
      expiresAt: 'Ablaufdatum (optional)',
      updated: 'Paket aktualisiert',
      deleted: 'Paket gelöscht',
      hasBookings: 'Dieses Paket hat zugehörige Buchungen und kann nicht gelöscht werden. Möchtest du es stattdessen deaktivieren?',
      deactivateTitle: 'Paket deaktivieren?',
      deactivate: 'Paket deaktivieren',
      deactivated: 'Paket deaktiviert',
      allServices: 'Alle Dienste',
    },
    services: {
      title: 'Dienste',
      addService: 'Neuer Dienst',
      name: 'Name',
      color: 'Farbe',
      capacity: 'Kapazität pro Slot',
      defaultDuration: 'Standarddauer',
      slotsPerBooking: 'Slots pro Buchung',
      slots: 'Slots',
      noServices: 'Keine Dienste',
      created: 'Dienst erstellt',
      updated: 'Dienst aktualisiert',
      manageServices: 'Dienste verwalten',
      toast: {
        loadError: 'Fehler beim Laden der Dienste',
        nameRequired: 'Name ist erforderlich',
        saveError: 'Fehler beim Speichern des Dienstes',
        confirmDelete: '"{{name}}" löschen?',
        deleted: 'Dienst gelöscht',
        deleteError: 'Fehler beim Löschen des Dienstes',
      },
    },
    requests: {
      title: 'Anfragen',
      addRequest: 'Neue Anfrage',
      rawText: 'Originaltext',
      detectedInfo: 'Erkannte Informationen',
      convertToBooking: 'In Buchung umwandeln',
      dismiss: 'Verwerfen',
      status: {
        pending: 'Ausstehend',
        converted: 'Erledigt',
        dismissed: 'Verworfen',
      },
      noRequests: 'Keine ausstehenden Anfragen',
      noResults: 'Keine Ergebnisse für diese Suche',
      processed: 'Verarbeitet',
      fields: {
        name: 'Name',
        phone: 'Telefon',
        service: 'Dienst',
        dateTime: 'Datum/Uhrzeit',
      },
      toast: {
        loadError: 'Fehler beim Laden der Anfragen',
        textRequired: 'Text ist erforderlich',
        created: 'Anfrage erstellt',
        createError: 'Fehler beim Erstellen der Anfrage',
        updated: 'Anfrage aktualisiert',
        updateError: 'Fehler beim Aktualisieren der Anfrage',
      },
    },
    staff: {
      title: 'Personal',
      addStaff: 'Neuer Benutzer',
      role: 'Rolle',
      userCreated: 'Benutzer erstellt',
      userUpdated: 'Benutzer aktualisiert',
      clientNote: 'Ein Kundenprofil wird automatisch erstellt und mit diesem Konto verknüpft.',
      roles: {
        superAdmin: 'Super Admin',
        centerAdmin: 'Zentrum-Admin',
        staff: 'Personal',
        client: 'Kunde',
      },
      noUsers: 'Keine Benutzer gefunden',
      toast: {
        loadError: 'Fehler beim Laden der Benutzer',
        emailNameRequired: 'E-Mail und Name sind erforderlich',
        passwordRequired: 'Passwort ist für neue Benutzer erforderlich',
        clientAlreadyHasAccess: 'Dieser Kunde hat bereits Zugang (ein verknüpfter Benutzer existiert bereits).',
        saveError: 'Fehler beim Speichern des Benutzers',
        confirmDelete: '"{{name}}" löschen?',
        deleted: 'Benutzer gelöscht',
        deleteError: 'Fehler beim Löschen des Benutzers',
      },
    },
    centers: {
      title: 'Zentren',
      addCenter: 'Neues Zentrum',
      name: 'Name',
      timezone: 'Zeitzone',
      openingTime: 'Öffnungszeit',
      closingTime: 'Schließzeit',
      slotDuration: 'Slot-Dauer',
      centerDetails: 'Zentrumsdetails',
      centerAdmin: 'Zentrum-Administrator',
      adminName: 'Admin-Name',
      adminEmailRequired: 'Admin-E-Mail ist erforderlich',
      adminPasswordRequired: 'Admin-Passwort erforderlich (mind. 6 Zeichen)',
      adminNote: 'Dieser Admin hat nur Zugriff auf dieses Zentrum.',
      noBilling: 'Zentrum ohne Abrechnung (Demo/Kulanz)',
      noBillingHelp: 'Wird nicht abgerechnet. Das Abonnement wird mit Status FREE erstellt und von der monatlichen Abrechnung ausgeschlossen.',
      whatsappManagedElsewhere: 'WhatsApp-Zugangsdaten werden im Tab „WhatsApp" konfiguriert (WhatsApp-Bereitstellung).',
      created: 'Zentrum mit Admin erstellt',
      updated: 'Zentrum aktualisiert',
      noCenters: 'Keine Zentren',
      nameRequired: 'Name ist erforderlich',
      manageCenters: 'Zentren verwalten',
      deactivate: 'Deaktivieren',
      reactivate: 'Reaktivieren',
      deleteHard: 'Dauerhaft löschen',
      resetPassword: 'Passwort zurücksetzen',
      exportClients: 'Kunden als CSV exportieren',
      exportClientsLoading: 'Kunden werden als CSV exportiert...',
      fichaClientTitle: 'Kundenprofil (pro Zentrum konfigurierbar)',
      fichaLabel: 'Profilabschnitte',
      fichaTip: 'Mit der Checkbox aktivieren/deaktivieren und mit den Pfeilen sortieren.',
      rgpdLegalText: 'Standard-DSGVO-Rechtstext',
      whatsappTitle: 'WhatsApp Business (pro Zentrum)',
      metaAccessToken: 'Meta Access Token',
      phoneNumberId: 'Phone Number ID',
      moveUp: 'Nach oben',
      moveDown: 'Nach unten',
      whatsapp: {
        statusLabel: 'WhatsApp-Status',
        provisionBtn: 'WhatsApp einrichten',
        refreshStatus: 'Status aktualisieren',
        status: {
          notConnected: 'Nicht verbunden',
          pendingReview: 'In Prüfung',
          pendingRegistration: 'Registrierung ausstehend',
          registering: 'Wird registriert...',
          active: 'Aktiv',
          failed: 'Fehler',
          rateLimited: 'Anfragelimit erreicht',
        },
        provision: {
          title: 'WhatsApp Business verbinden',
          accessToken: 'Meta Access Token',
          wabaId: 'WABA ID',
          phoneNumberId: 'Phone Number ID',
          pin: 'PIN (6 Ziffern)',
          pinHelp: 'PIN schützt die Nummer in der Cloud API. Für die Neuregistrierung erforderlich.',
          displayName: 'Anzeigename (optional)',
          submit: 'Manuell einrichten',
          connectWithFacebook: 'Mit Facebook verbinden',
          embeddedSignupHint: 'Öffnet den Meta-Assistenten, um die WABA dieses Zentrums zu verknüpfen.',
          orManual: 'Oder Daten manuell eingeben',
        },
        toast: {
          provisionSuccess: 'WhatsApp erfolgreich eingerichtet',
          provisionError: 'Fehler beim Einrichten von WhatsApp',
          statusRefreshed: 'Status aktualisiert',
          statusError: 'Fehler beim Abrufen des WhatsApp-Status',
          sdkNotLoaded: 'Facebook SDK nicht verfügbar. Seite neu laden.',
          signupCancelled: 'Anmeldung abgebrochen',
          noWabaData: 'Keine WABA-Daten empfangen — manuelles Formular verwenden',
        },
        guide: {
          step1: { title: 'Meta Business Manager öffnen', text: 'Gehe zu business.facebook.com → WhatsApp-Konten', btn: 'Meta Business öffnen' },
          step2: { title: 'WhatsApp-Konto für das Zentrum erstellen', text: 'Klicke + Hinzufügen → Neues Konto erstellen → Zentrumsnamen eingeben' },
          step3: { title: 'Telefonnummer hinzufügen', text: 'Im erstellten Konto → Telefonnummern → Nummer hinzufügen → Zentrumstelefonnummer eingeben. Der Kunde erhält eine SMS mit dem Verifizierungscode.' },
          step4: { title: 'Phone Number ID kopieren', text: 'WhatsApp-Manager → Nummer auswählen → Telefonnummer-ID kopieren' },
          step5: { title: 'WABA ID kopieren', text: 'Im WhatsApp-Konto → Kennung kopieren' },
          step6: { title: 'Sicherheits-PIN festlegen' },
          connectBtn: 'WhatsApp verbinden',
        },
      },
      toast: {
        loadError: 'Fehler beim Laden der Zentren',
        passwordReset: 'Passwort zurückgesetzt',
        passwordResetError: 'Passwort konnte nicht zurückgesetzt werden',
        confirmResetPassword: 'Passwort von {{label}} zurücksetzen?\n\nEin temporäres Passwort wird generiert und zum Kopieren angezeigt.',
        confirmDeactivate: 'Dieses Zentrum deaktivieren?',
        deactivated: 'Zentrum deaktiviert',
        deactivateError: 'Fehler beim Deaktivieren des Zentrums',
        reactivated: 'Zentrum reaktiviert',
        reactivateError: 'Fehler beim Reaktivieren des Zentrums',
        exportClientsError: 'Fehler beim Exportieren der Kunden als CSV',
        confirmDeleteHard: 'Dieses Zentrum dauerhaft löschen? Nur möglich, wenn keine verknüpften Daten vorhanden sind.',
        deleted: 'Zentrum gelöscht',
        cannotDelete: 'Kann nicht gelöscht werden: Es sind Daten verknüpft. Zentrum deaktivieren.',
      },
    },
    settings: {
      title: 'Einstellungen',
      centerSettings: 'Zentrumseinstellungen',
      language: 'Sprache',
      profile: 'Profil',
      connect: {
        title: 'Stripe Connect',
        description: 'Verknüpfe das Stripe-Konto deines Zentrums über ein sicheres Onboarding.',
        status: 'Status',
        action: 'Aktivieren / Onboarding fortsetzen',
        requirements: 'Anforderungen prüfen',
        error: 'Stripe Connect konnte nicht gestartet werden',
      },
      tabs: {
        general: 'Allgemein',
        center: 'Zentrum',
        schedule: 'Zeitplan',
      },
      cancelRules: {
        title: 'Stornierungsregeln',
        rule: 'Regel',
        dayBefore: 'Tag zuvor',
        sameDay: 'Gleicher Tag',
        cutoffDayBefore: 'Fristzeit (Tag zuvor)',
        cutoffSameDay: 'Fristzeit (gleicher Tag)',
        note: 'Außerhalb der Regel: wird als NO_SHOW markiert, Sitzung abgezogen / Schulden erzeugt.',
      },
      weeklySchedule: {
        title: 'Wochenplan',
        noTemplates: 'Keine Vorlagen',
        newTemplate: 'Neue Vorlage',
        editTemplate: 'Vorlage bearbeiten',
        breaks: 'Pausen',
        noBreaks: 'Keine Pausen',
        slots: 'Slots',
        noSlots: 'Keine Slots',
        add: 'Hinzufügen',
        nameLabel: 'Name',
        namePlaceholder: 'Z.B.: Woche Typ A',
        clients: 'Kunden',
        searchClient: 'Kunde suchen...',
        editorDescription: 'Wochenvorlage-Editor',
        // template-service-break-semantics (Hallazgo 5, task 9.1.1):
        // placeholders del editor de breaks de plantilla (Settings.js).
        breakGlobal: 'Global (ganzer Slot)',
        breakAllVariants: 'Alle Varianten',
        // template-service-break-semantics (Hallazgo 6, task 9.3.1).
        breakFrom: 'Von',
        breakTo: 'Bis',
      },
      days: {
        mon: 'Mo',
        tue: 'Di',
        wed: 'Mi',
        thu: 'Do',
        fri: 'Fr',
        sat: 'Sa',
        sun: 'So',
      },
      toast: {
        loadTemplatesError: 'Fehler beim Laden der Vorlagen',
        saveError: 'Fehler beim Speichern der Einstellungen',
        saveTemplateError: 'Fehler beim Speichern der Vorlage',
        deleteTemplateError: 'Fehler beim Löschen der Vorlage',
        templateNameRequired: 'Name ist erforderlich',
        templateSaved: 'Vorlage gespeichert',
        templateDeleted: 'Vorlage gelöscht',
        confirmDeleteTemplate: 'Vorlage "{{name}}" löschen?',
        // template-service-break-semantics (Hallazgo 6, task 9.3.1).
        breakTimeRequired: 'Bitte gib für jede Pause Start- und Endzeit an, bevor du speicherst',
      },
    },
    auditLog: {
      title: 'Prüfprotokoll',
      user: 'Benutzer',
      action: 'Aktion',
      entity: 'Entität',
      timestamp: 'Datum und Uhrzeit',
      details: 'Details',
      detailMessages: {
        createdBooking: 'Buchung erstellt für {{client}} - {{service}}',
        deletedBooking: 'Buchung gelöscht',
      },
      actions: {
        create: 'Erstellt',
        update: 'Aktualisiert',
        delete: 'Gelöscht',
        deduct: 'Abgezogen',
        apply: 'Vorlage angewendet',
      },
      entities: {
        booking: 'Buchung',
        client: 'Kunde',
        user: 'Benutzer',
        center: 'Zentrum',
        calendar: 'Dienst',
        session_pack: 'Paket',
        request: 'Anfrage',
        waitlist: 'Warteliste',
        weekly_template: 'Wochenvorlage',
        unknown: 'Sonstiges',
      },
      empty: 'Keine Prüfprotokolleinträge gefunden',
      loadError: 'Fehler beim Laden des Prüfprotokolls',
    },
    time: {
      today: 'Heute',
      yesterday: 'Gestern',
      tomorrow: 'Morgen',
    },
    layout: {
      notifications: {
        markAllRead: 'Alle als gelesen markieren',
        markRead: 'Als gelesen markieren',
        empty: 'Keine Benachrichtigungen',
        open: 'Öffnen',
      },
      waitlistOffer: {
        title: 'Platz frei — Warteliste',
        body: 'Ein Platz wurde durch eine Stornierung freigegeben und dem ersten Kunden auf der Warteliste angeboten.',
        clientLabel: 'Kunde',
        serviceLabel: 'Dienst',
        slotLabel: 'Slot',
        confirmBtn: 'OK — Bestätigen',
      },
    },
    waitlist: {
      title: 'Warteliste',
      newRequest: 'Neue Anfrage',
      cancelConfirm: 'Diesen Warteeintrag stornieren?',
      clientSelected: 'Kunde ausgewählt',
      searchClient: 'Tippen und Kunden auswählen',
      searchClientPlaceholder: 'Kunde (nach Name suchen)',
      selectService: 'Dienst',
      selectDay: 'Tag auswählen',
      timeCarousel: 'Uhrzeit (Karussell oder eingeben)',
      noEntries: 'Keine Wartelisteneinträge.',
      position: 'Position {{n}} in der Liste',
      cancelRequest: 'Anfrage stornieren',
      force: 'Erzwingen',
      columns: {
        client: 'Kunde',
        service: 'Dienst',
        slot: 'Slot',
      },
      status: {
        waiting: 'Wartend',
        offered: 'Angeboten',
        confirmed: 'Bestätigt',
        expired: 'Abgelaufen',
        cancelled: 'Storniert',
      },
      toast: {
        loadError: 'Fehler beim Laden der Warteliste',
        created: 'Eintrag erstellt',
        forced: 'Erzwungen',
        cancelled: 'Storniert',
        bookingConfirmed: 'Buchung von der Warteliste bestätigt',
        fillRequired: 'Kunde, Dienst und Datum/Uhrzeit ausfüllen',
        cannotClose: 'Hinweis konnte nicht geschlossen werden',
        cannotConfirm: 'Angebot konnte nicht bestätigt werden',
        cannotForce: 'Konnte nicht erzwungen werden',
        cannotCancel: 'Konnte nicht storniert werden',
        cannotCreate: 'Konnte nicht erstellt werden',
      },
    },
    clientProfile: {
      access: {
        title: 'Zugang zum persönlichen Bereich',
        enabled: 'Aktiviert',
        disabled: 'Deaktiviert',
        resetPassword: 'Passwort zurücksetzen',
        disableAccess: 'Zugang deaktivieren',
        enableAccess: 'Zugang aktivieren',
        dialogTitleReset: 'Zugang zurücksetzen',
        dialogTitleEnable: 'Zugang aktivieren',
        emailLabel: 'E-Mail *',
        passwordLabel: 'Passwort *',
        adminNote: 'Der Admin legt ein neues Passwort fest, sieht es auf dem Bildschirm und teilt es dem Kunden mit.',
      },
      tabs: {
        ficha: 'Profil',
        personal: 'Personal',
      },
      personal: {
        loading: 'Personal wird geladen…',
        emptyStaff: 'Kein aktives Personal',
        error: 'Personal konnte nicht geladen werden',
      },
      sections: {
        personalData: 'Persönliche Daten',
        rgpd: 'DSGVO',
      },
      fields: {
        firstName: 'Vorname',
        surname: 'Nachname',
        phone: 'Telefon',
        email: 'E-Mail',
        birthDate: 'Geburtsdatum',
        professionalSector: 'Berufsfeld',
        address: 'Adresse (optional)',
        legalText: 'Rechtstext (wird im Kundenprofil gespeichert)',
      },
      rgpd: {
        consent: 'DSGVO-Zustimmung',
        dateLabel: 'Datum:',
      },
      toast: {
        loadError: 'Fehler beim Laden des Kunden',
        updated: 'Kunde aktualisiert',
        updateError: 'Fehler beim Aktualisieren des Kunden',
        emailPasswordRequired: 'E-Mail und Passwort sind erforderlich',
        passwordUpdated: 'Passwort aktualisiert',
        accessCreated: 'Zugang erstellt',
        accessReactivated: 'Zugang reaktiviert',
        accessError: 'Zugang konnte nicht gespeichert werden',
        accessDisabled: 'Zugang deaktiviert',
        accessDisableError: 'Zugang konnte nicht deaktiviert werden',
      },
    },

    contentEngine: {
      nav: 'Content Engine',
    },
    aiLeadScanner: {
      nav: 'Lead Scanner',
      title: 'AI Lead Scanner',
      todayFollowUps: {
        title: 'Heutige Nachverfolgungen',
        empty: 'Keine anstehenden Nachverfolgungen für heute',
        overdueLabel: 'Überfällig',
      },
      activeFollowUps: {
        title: 'Aktive Nachverfolgungen',
        empty: 'Keine aktiven Nachverfolgungen',
      },
      discardSuggestions: {
        title: 'Verwerfungsvorschläge',
        empty: 'Kein Lead hat das Nachverfolgungslimit erreicht',
      },
      filters: {
        sector: 'Branche',
        city: 'Stadt',
        priority: 'Priorität',
        status: 'Status',
        temperature: 'Temperatur',
        minScore: 'Mindestpunktzahl',
        search: 'Nach Name suchen',
        searchPlaceholder: 'Name des Unternehmens...',
        allSectors: 'Alle Branchen',
        allPriorities: 'Alle Prioritäten',
        allStatuses: 'Alle Status',
        allTemperatures: 'Alle',
        clear: 'Filter zurücksetzen',
      },
      table: {
        businessName: 'Unternehmen',
        sector: 'Branche',
        city: 'Stadt',
        score: 'Score',
        priority: 'Priorität',
        status: 'Status',
        temperature: 'Temp.',
        lastContacted: 'Letzter Kontakt',
        nextFollowUp: 'Nächste Nachverfolgung',
        actions: 'Aktionen',
        noLeads: 'Keine Leads mit diesen Filtern',
        viewDetail: 'Profil ansehen',
        never: '—',
        loadError: 'Leads konnten nicht geladen werden',
      },
      actions: {
        addLead: 'Lead hinzufügen',
        importExcel: 'Excel importieren',
        analyzeSelected: 'Ausgewählte analysieren',
        discardSelected: 'Ausgewählte verwerfen',
      },
      discardDialog: {
        title: '{{count}} Lead(s) verwerfen?',
        description: 'Du findest sie später wieder, indem du nach Status "Verworfen" filterst. Das ist kein echtes Löschen — der Lead bleibt bestehen, nur der Status ändert sich.',
        confirm: 'Verwerfen',
      },
      addLeadModal: {
        businessName: 'Name des Unternehmens',
        businessNameRequired: 'Der Name des Unternehmens ist erforderlich',
        province: 'Provinz',
        phone: 'Telefon',
        email: 'E-Mail',
        create: 'Lead erstellen',
        success: 'Lead erfolgreich erstellt',
        error: 'Lead konnte nicht erstellt werden',
        duplicateReasonDomain: 'Es existiert bereits ein Lead mit derselben Webseite: {{name}}',
        duplicateReasonPhone: 'Es existiert bereits ein Lead mit derselben Telefonnummer: {{name}}',
        duplicateReasonNameCity: 'Es existiert bereits ein Lead mit demselben Namen und derselben Stadt: {{name}}',
        viewExisting: 'Bestehenden Lead ansehen',
      },
      importModal: {
        runDryRun: 'Datei analysieren',
        totalRows: 'Zeilen insgesamt',
        imported: 'Würden importiert',
        duplicates: 'Duplikate',
        invalidRows: 'Ungültige Zeilen (ohne Unternehmensname)',
        contactadoDefaultedWhatsapp: 'Status "Kontaktiert" — Kanal standardmäßig WhatsApp',
        followUpNoDate: 'Nachverfolgung ohne Datum',
        addressUnparsed: 'Adresse konnte nicht verarbeitet werden',
        unrecognizedStatuses: 'Nicht erkannte Status',
        rowRef: 'Blatt {{sheet}}, Zeile {{row}}',
        confirmWarning: 'Dadurch werden die echten Leads in die Datenbank geschrieben. Prüfe die Zusammenfassung vor der Bestätigung.',
        confirmImport: 'Import bestätigen',
        success: '{{count}} Leads erfolgreich importiert',
        error: 'Import konnte nicht abgeschlossen werden',
      },
      pagination: {
        showing: '{{from}}–{{to}} von {{total}} angezeigt',
        previous: 'Zurück',
        next: 'Weiter',
      },
      calendar: {
        title: 'Nachverfolgungskalender',
      },
      status: {
        NEW: 'Neu',
        READY_TO_CONTACT: 'Kontaktbereit',
        CONTACTED_WHATSAPP: 'Kontaktiert (WhatsApp)',
        CONTACTED_EMAIL: 'Kontaktiert (E-Mail)',
        CONTACTED_CALL: 'Kontaktiert (Anruf)',
        FOLLOW_UP: 'Nachverfolgung',
        DEMO_PENDING: 'Demo ausstehend',
        DEMO_SCHEDULED: 'Demo geplant',
        EVALUATING_PROPOSAL: 'Angebot wird geprüft',
        CUSTOMER: 'Kunde',
        NOT_INTERESTED: 'Kein Interesse',
        DISCARDED: 'Verworfen',
        ERROR: 'Fehler',
      },
      priority: {
        high: 'Hoch',
        medium: 'Mittel',
        low: 'Niedrig',
        discard: 'Verwerfen',
        unknown: 'Nicht bewertet',
      },
      temperature: {
        HOT: 'Heiß',
        WARM: 'Warm',
        COLD: 'Kalt',
      },
      sector: {
        personal_trainer: 'Personal Trainer',
        small_gym: 'Kleines Fitnessstudio',
        functional_training: 'Funktionelles Training',
        boutique_gym: 'Boutique-Fitnessstudio',
        cross_training: 'Cross Training',
        pilates: 'Pilates',
        yoga: 'Yoga',
        physiotherapy: 'Physiotherapie',
        osteopathy: 'Osteopathie',
        nutritionist: 'Ernährungsberatung',
        psychologist: 'Psychologie',
        massage_therapist: 'Masseur',
        manual_therapist: 'Manualtherapeut',
        wellness_center: 'Wellnesscenter',
        chiropractor: 'Chiropraktiker',
        unknown: 'Nicht definiert',
      },
      leadDetail: {
        back: 'Zurück',
        profile: 'Profil',
        address: 'Adresse',
        website: 'Webseite',
        instagram: 'Instagram',
        notes: 'Notizen',
        needsWebsite: 'Keine eigene Webseite',
        loadError: 'Lead konnte nicht geladen werden',
        notFound: 'Lead nicht gefunden',
        markContacted: 'Als kontaktiert markieren',
        markContactedWhatsapp: 'Per WhatsApp',
        markContactedEmail: 'Per E-Mail',
        markContactedCall: 'Per Anruf',
        changeStatus: 'Status ändern',
        markDiscard: 'Verwerfen',
        followUpCount: 'Nachverfolgungen: {{count}}/{{limit}}',
        discardSuggestionDescription: 'Dieser Lead hat das Limit von {{limit}} Nachverfolgungen erreicht, ohne voranzukommen. Du kannst ihn verwerfen oder es manuell weiter versuchen.',
        pasteManualContent: 'Webseiten-Inhalt manuell einfügen',
        pasteManualContentTitle: 'Webseiten-Inhalt manuell einfügen',
        pasteManualContentDescription: 'Die automatische Analyse der Webseite ist beim Zugriffsversuch fehlgeschlagen. Füge hier den Text ein, den du selbst aus dem Browser kopierst — der Rest der Analyse (Branche, Signale, Score, Nachrichten) wird wie immer aus diesem Text erstellt.',
        pasteManualContentLabel: 'Webseiten-Inhalt',
        markFollowUp: 'Nachverfolgung festlegen',
        followUpDate: 'Datum der Nachverfolgung',
        followUpNote: 'Notiz (optional)',
        markNotInterested: 'Kein Interesse',
        regenerateMessages: 'Nachrichten neu erstellen',
        reanalyze: 'Neu analysieren',
        actionSuccess: 'Erledigt',
        actionError: 'Aktion konnte nicht abgeschlossen werden',
        noAnalysisYet: 'Dieser Lead hat noch keine Analyse. Nutze "Neu analysieren", um eine zu erstellen.',
        noMessagesYet: 'Dieser Lead hat noch keine generierten Nachrichten.',
        save: 'Speichern',
        cancel: 'Abbrechen',
        edit: 'Bearbeiten',
      },
      editLeadModal: {
        title: 'Lead bearbeiten',
        success: 'Lead erfolgreich aktualisiert',
        error: 'Lead konnte nicht aktualisiert werden',
      },
      messageCard: {
        copy: 'Kopieren',
        copied: 'In die Zwischenablage kopiert',
        copyError: 'Konnte nicht kopiert werden',
        words: 'Wörter',
        subject: 'Betreff',
        exceedsLimit: 'Überschreitet die empfohlene Grenze von 180 Wörtern, vor dem Kopieren prüfen',
        whatsappInitial: 'Erste WhatsApp-Nachricht',
        emailInitial: 'Erste E-Mail',
        followUp1: 'Nachverfolgung 1',
        followUp2: 'Nachverfolgung 2',
        callScript: 'Gesprächsleitfaden',
        internalNotes: 'Interne Notizen',
      },
      scoreBreakdown: {
        positive: 'Positive Signale',
        negative: 'Negative Signale',
      },
      websiteAnalysis: {
        title: 'Webseiten-Analyse',
        confidence: 'Vertrauen',
        excluded: 'Ausgeschlossen',
        detectedSector: 'Erkannte Branche',
        evidence: 'Belege',
      },
      signals: {
        has_whatsapp: 'WhatsApp sichtbar',
        has_online_booking: 'Online-Buchung',
        has_booking_platform: 'Buchungsplattform',
        has_session_packs: 'Sitzungspakete',
        has_group_classes: 'Gruppenkurse',
        has_schedule: 'Veröffentlichter Zeitplan',
        has_multiple_professionals: 'Mehrere Fachkräfte',
        owner_visible: 'Inhaber sichtbar',
        has_cancellation_sensitive: 'Stornierungsrichtlinie',
        is_franchise: 'Franchise',
        is_ecommerce_only: 'Nur E-Commerce',
        website_active: 'Aktive Webseite',
        has_instagram_link: 'Instagram-Link',
      },
    },
    errors: {
      session_expired: 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
      invalid_token: 'Das Zugriffstoken ist ungültig. Bitte melden Sie sich erneut an.',
      user_not_found: 'Wir konnten Ihren Benutzer nicht finden. Überprüfen Sie Ihre Zugangsdaten und versuchen Sie es erneut.',
      insufficient_permissions: 'Sie sind nicht berechtigt, diese Aktion auszuführen. Bitten Sie bei Bedarf einen Administrator um Zugriff.',
      cross_center_access_denied: 'Diese Aktion betrifft ein anderes Zentrum und Ihr Konto hat keinen Zugriff. Wenden Sie sich an den Administrator des entsprechenden Zentrums.',
      account_not_linked: 'Ihr Benutzerkonto ist noch nicht mit einem Kunden verknüpft. Wenden Sie sich an das Zentrum, um die Registrierung abzuschließen.',
      slot_already_booked: 'Dieser Zeitraum ist bereits gebucht. Wählen Sie einen anderen verfügbaren Termin.',
      idempotency_key_payload_mismatch: 'Beim Senden Ihrer Anfrage ist ein Problem aufgetreten. Laden Sie die Seite neu und versuchen Sie es erneut.',
      duplicate_booking: 'Sie haben bereits eine identische Buchung. Der Termin wurde nicht dupliziert.',
      concurrent_modification: 'Ein anderer Benutzer hat diese Daten bearbeitet, während Sie sie geändert haben. Laden Sie die Seite neu und versuchen Sie es erneut.',
      validation_error: 'Einige Daten sind ungültig ({{field}}). Korrigieren Sie die markierten Felder und versuchen Sie es erneut.',
      date_format_error: 'Das eingegebene Datum hat nicht das erwartete Format. Verwenden Sie JJJJ-MM-TT.',
      rate_limit_exceeded: 'Sie haben in kurzer Zeit zu viele Anfragen gesendet. Warten Sie einen Moment, bevor Sie es erneut versuchen.',
      // R1.11 / D11 — `POST /clients/{id}/access` error codes.
      email_already_in_use: 'Diese E-Mail-Adresse wird bereits verwendet.',
      invalid_role_for_link: 'Dieser Benutzer kann mit seiner aktuellen Rolle nicht mit einem Kundenprofil verknüpft werden.',
      user_already_linked: 'Dieser Benutzer ist bereits mit einem anderen Profil verknüpft.',
      client_not_found: 'Das Kundenprofil wurde nicht gefunden.',
      transactions_unavailable: 'Das System kann den Vorgang derzeit nicht abschließen. Bitte versuchen Sie es in einigen Minuten erneut.',
      http_401: 'Sie sind nicht authentifiziert. Bitte melden Sie sich an, um fortzufahren.',
      http_403: 'Sie sind nicht berechtigt, auf diese Ressource zuzugreifen.',
      http_404: 'Die angeforderte Ressource wurde nicht gefunden.',
      http_409: 'Die Anfrage steht im Konflikt mit dem aktuellen Zustand. Laden Sie die Seite neu und versuchen Sie es erneut.',
      http_422: 'Die gesendeten Daten sind ungültig. Überprüfen Sie die Felder und versuchen Sie es erneut.',
      http_429: 'Sie haben zu viele Anfragen gesendet. Warten Sie einen Moment, bevor Sie fortfahren.',
    },
    success: {
      placeholder: 'Vorgang erfolgreich abgeschlossen.',
      layout: {
        waitlistConfirmed: 'Buchung von der Warteliste bestätigt',
        waitlistConfirmTaken: 'Dieses Angebot ist nicht mehr verfügbar. Bitten Sie den Kunden, einen anderen Wartelistenplatz zu wählen.',
        notificationDeleteError: 'Benachrichtigung konnte nicht gelöscht werden',
        legalAcceptedSaaS: 'SaaS-Vertrag akzeptiert',
        legalAcceptedDpa: 'DPA-Anhang akzeptiert',
        legalAcceptedPrivacy: 'Datenschutzerklärung akzeptiert',
        legalAcceptedTerms: 'Nutzungsbedingungen akzeptiert',
        logoutError: 'Abmeldung konnte nicht sicher abgeschlossen werden',
        restoreSuperAdminError: 'Rückkehr zu SuperAdmin konnte nicht sicher abgeschlossen werden',
      },
      whatsapp: {
        timeoutUpdateError: 'Auto-Return-Timeout konnte nicht aktualisiert werden',
      },
      planner: {
        breakDeleted: 'Pause gelöscht',
        breakCreated: 'Pause erstellt',
        selectVariantRequired: 'Wähle eine Variante, bevor du die Buchung erstellst.',
        staffUpdated: 'Personal aktualisiert',
        staffAssigned: 'Personal zugewiesen',
        noCompatibleStaff: 'Kein kompatibles Personal verfügbar. Die Buchung bleibt ausstehend.',
        bookingAlreadyHasStaff: 'Dieser Buchung ist bereits Personal zugewiesen.',
        noteSaved: 'Notiz gespeichert',
        noteSaveError: 'Fehler beim Speichern der Notiz',
      },
      clientProfile: {
        planMonthlyCreated: 'Monatsplan erstellt und dem Kunden zugewiesen',
        packNotIdentified: 'Fehler: Paket konnte nicht identifiziert werden',
        planUpdated: 'Plan aktualisiert',
        planCancelled: 'Plan storniert',
        recoveryDateRequired: 'Gib das Wiederherstellungsdatum an',
        recoveryPackCreated: 'Wiederherstellungspaket erstellt',
        consentRecorded: 'Zustimmung erfasst',
        consentError: 'Fehler beim Erfassen der Zustimmung',
        privacyRegistered: 'Datenschutzerklärung erfasst',
        termsRegistered: 'Nutzungsbedingungen erfasst',
      },
      whatsappDashboard: {
        statsLoadError: 'WhatsApp-Statistiken konnten nicht geladen werden',
        configUpdateError: 'Konfiguration konnte nicht aktualisiert werden',
      },
      staff: {
        scheduleSaved: 'Dienstplan gespeichert',
      },
      centers: {
        websiteCreated: 'Öffentliche Webseiten-Konfiguration erstellt',
        websiteSaved: 'Öffentliche Webseite gespeichert',
        websiteActivated: 'Öffentliche Webseite aktiviert',
        websiteDeactivated: 'Öffentliche Webseite deaktiviert',
        notFound: 'Zentrum nicht gefunden.',
        configSaved: 'Konfiguration gespeichert',
        invalidMinutes: 'Gib eine gültige Minutenzahl ein',
        invalidCredits: 'Gib eine gültige Anzahl Credits ein',
        vapiSynced: 'Vapi-Konfiguration gespeichert und synchronisiert',
        whatsappUnlinked: 'WhatsApp erfolgreich getrennt.',
      },
      notifications: {
        loadError: 'Fehler beim Laden der Benachrichtigungen',
        markReadError: 'Konnte nicht als gelesen markiert werden',
        markedAllRead: 'Als gelesen markiert',
        markAllError: 'Alle zu markieren fehlgeschlagen',
        deleted: 'Benachrichtigung gelöscht',
        deleteError: 'Konnte nicht gelöscht werden',
      },
      costDashboard: {
        subscriptionCreated: 'Abonnement erstellt',
        subscriptionUpdated: 'Abonnement aktualisiert',
        subscriptionCancelled: 'Abonnement storniert',
        cancelError: 'Fehler beim Stornieren',
        loadError: 'Fehler beim Laden des Kosten-Dashboards',
        exportError: 'Fehler beim Exportieren',
      },
      dashboard: {
        saasStatsError: 'Fehler beim Laden der SaaS-Statistiken',
        aiSecretaryStatsError: 'Fehler beim Laden der KI-Sekretariats-Statistiken',
        exportKpisError: 'Fehler beim Exportieren der KPIs',
      },
      contentEngine: {
        draftsLoadError: 'Entwürfe konnten nicht geladen werden',
        draftSaved: 'Entwurf gespeichert',
        editSaveError: 'Bearbeitung konnte nicht gespeichert werden',
        mdxDownloaded: 'MDX heruntergeladen — in adamsched-web/content/blog/ in einem Branch ablegen und PR öffnen',
      },
      clients: {
        loadError: 'Fehler beim Laden der Kunden',
        archived: 'Kunde archiviert',
        restored: 'Kunde wiederhergestellt',
        deleted: 'Kunde gelöscht',
        nameRequired: 'Name ist erforderlich',
        created: 'Kunde erstellt',
        createError: 'Kunde konnte nicht erstellt werden',
      },
      settings: {
        aiSecretaryToggleError: 'Fehler beim Umschalten des KI-Sekretariats-Status',
        configUpdateError: 'Fehler beim Aktualisieren der Konfiguration',
        saveError: 'Fehler beim Speichern',
      },
    },
  },
};

export const getTranslation = (language, path) => {
  const keys = path.split('.');
  const supportedLocales = Object.keys(translations);
  // If the requested locale is not in our supported set, fall back to en and
  // warn (R2.AC.5) — the application should never pass an unsupported locale
  // here in production (AuthContext defaults to 'es' or the persisted value,
  // which is always 'es'/'en'/'de'); a stray value signals a bug.
  const effectiveLocale = supportedLocales.includes(language) ? language : 'en';
  if (effectiveLocale !== language) {
    // eslint-disable-next-line no-console
    console.warn(`[i18n] unsupported locale "${language}" — falling back to en`);
  }
  let result = translations[effectiveLocale];

  for (const key of keys) {
    result = result?.[key];
    if (result === undefined) {
      // Missing translation for the requested locale — fall back to English
      // (R2.AC.5) and surface the gap in development so it's never silently
      // shipped. Production builds keep the warn too: silent missing
      // translations have caused real UX regressions in the past.
      // eslint-disable-next-line no-console
      console.warn(`[i18n] missing key "${path}" for locale "${language}" — falling back to en`);
      result = translations.en;
      for (const k of keys) {
        result = result?.[k];
      }
      break;
    }
  }

  return result || path;
};
